
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireb7cf"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireb7cf"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("6hxRz", function(module, exports) {

$parcel$export(module.exports, "a", function () { return g; });
$parcel$export(module.exports, "b", function () { return tt; });
$parcel$export(module.exports, "c", function () { return L; });
$parcel$export(module.exports, "d", function () { return rn; });
$parcel$export(module.exports, "e", function () { return Zi; });
$parcel$export(module.exports, "f", function () { return tn; });
$parcel$export(module.exports, "g", function () { return en; });
$parcel$export(module.exports, "h", function () { return V; });
$parcel$export(module.exports, "i", function () { return nn; });
$parcel$export(module.exports, "j", function () { return wn; });

var $ihoyg = parcelRequire("ihoyg");
var $4a739abef963ef65$require$Buffer = $ihoyg.Buffer;
var te = {}, Be = function(t, e, i, n, r) {
    var o = new Worker(te[e] || (te[e] = URL.createObjectURL(new Blob([
        t + ';addEventListener("error",function(e){e=e.error;postMessage({$e$:[e.message,e.code,e.stack]})})'
    ], {
        type: "text/javascript"
    }))));
    return o.onmessage = function(a) {
        var s = a.data, l = s.$e$;
        if (l) {
            var h = new Error(l[0]);
            h.code = l[1], h.stack = l[2], r(h, null);
        } else r(null, s);
    }, o.postMessage(i, n), o;
}, x = Uint8Array, Y = Uint16Array, se = Int32Array, zt = new x([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0,
    0,
    0,
    0
]), Ft = new x([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13,
    0,
    0
]), le = new x([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]), ue = function(t, e) {
    for(var i = new Y(31), n = 0; n < 31; ++n)i[n] = e += 1 << t[n - 1];
    for(var r = new se(i[30]), n = 1; n < 30; ++n)for(var o = i[n]; o < i[n + 1]; ++o)r[o] = o - i[n] << 5 | n;
    return {
        b: i,
        r: r
    };
}, he = ue(zt, 2), Dt = he.b, Je = he.r;
Dt[28] = 258, Je[258] = 28;
var Re = ue(Ft, 0), de = Re.b, yt = new Y(32768);
for(b = 0; b < 32768; ++b)X = (b & 43690) >> 1 | (b & 21845) << 1, X = (X & 52428) >> 2 | (X & 13107) << 2, X = (X & 61680) >> 4 | (X & 3855) << 4, yt[b] = ((X & 65280) >> 8 | (X & 255) << 8) >> 1;
var X, b, nt = function(t, e, i) {
    for(var n = t.length, r = 0, o = new Y(e); r < n; ++r)t[r] && ++o[t[r] - 1];
    var a = new Y(e);
    for(r = 1; r < e; ++r)a[r] = a[r - 1] + o[r - 1] << 1;
    var s;
    if (i) {
        s = new Y(1 << e);
        var l = 15 - e;
        for(r = 0; r < n; ++r)if (t[r]) for(var h = r << 4 | t[r], u = e - t[r], d = a[t[r] - 1]++ << u, f = d | (1 << u) - 1; d <= f; ++d)s[yt[d] >> l] = h;
    } else for(s = new Y(n), r = 0; r < n; ++r)t[r] && (s[r] = yt[a[t[r] - 1]++] >> 15 - t[r]);
    return s;
}, ut = new x(288);
for(b = 0; b < 144; ++b)ut[b] = 8;
var b;
for(b = 144; b < 256; ++b)ut[b] = 9;
var b;
for(b = 256; b < 280; ++b)ut[b] = 7;
var b;
for(b = 280; b < 288; ++b)ut[b] = 8;
var b, ce = new x(32);
for(b = 0; b < 32; ++b)ce[b] = 5;
var b, fe = nt(ut, 9, 1), pe = nt(ce, 5, 1), _t = function(t) {
    for(var e = t[0], i = 1; i < t.length; ++i)t[i] > e && (e = t[i]);
    return e;
}, U = function(t, e, i) {
    var n = e / 8 | 0;
    return (t[n] | t[n + 1] << 8) >> (e & 7) & i;
}, vt = function(t, e) {
    var i = e / 8 | 0;
    return (t[i] | t[i + 1] << 8 | t[i + 2] << 16) >> (e & 7);
}, me = function(t) {
    return (t + 7) / 8 | 0;
}, gt = function(t, e, i) {
    (e == null || e < 0) && (e = 0), (i == null || i > t.length) && (i = t.length);
    var n = new x(i - e);
    return n.set(t.subarray(e, i)), n;
}, _e = [
    "unexpected EOF",
    "invalid block type",
    "invalid length/literal",
    "invalid distance",
    "stream finished",
    "no stream handler",
    ,
    "no callback",
    "invalid UTF-8 data",
    "extra field too long",
    "date not in range 1980-2099",
    "filename too long",
    "stream finishing",
    "invalid zip data"
], T = function(t, e, i) {
    var n = new Error(e || _e[t]);
    if (n.code = t, Error.captureStackTrace && Error.captureStackTrace(n, T), !i) throw n;
    return n;
}, ve = function(t, e, i, n) {
    var r = t.length, o = n ? n.length : 0;
    if (!r || e.f && !e.l) return i || new x(0);
    var a = !i || e.i != 2, s = e.i;
    i || (i = new x(r * 3));
    var l = function(Qt) {
        var Yt = i.length;
        if (Qt > Yt) {
            var Zt = new x(Math.max(Yt * 2, Qt));
            Zt.set(i), i = Zt;
        }
    }, h = e.f || 0, u = e.p || 0, d = e.b || 0, f = e.l, p = e.d, m = e.m, c = e.n, v = r * 8;
    do {
        if (!f) {
            h = U(t, u, 1);
            var _ = U(t, u + 1, 3);
            if (u += 3, _) {
                if (_ == 1) f = fe, p = pe, m = 9, c = 5;
                else if (_ == 2) {
                    var S = U(t, u, 31) + 257, y = U(t, u + 10, 15) + 4, E = S + U(t, u + 5, 31) + 1;
                    u += 14;
                    for(var M = new x(E), D = new x(19), I = 0; I < y; ++I)D[le[I]] = U(t, u + I * 3, 7);
                    u += y * 3;
                    for(var F = _t(D), j = (1 << F) - 1, q = nt(D, F, 1), I = 0; I < E;){
                        var A = q[U(t, u, j)];
                        u += A & 15;
                        var k = A >> 4;
                        if (k < 16) M[I++] = k;
                        else {
                            var B = 0, W = 0;
                            for(k == 16 ? (W = 3 + U(t, u, 3), u += 2, B = M[I - 1]) : k == 17 ? (W = 3 + U(t, u, 7), u += 3) : k == 18 && (W = 11 + U(t, u, 127), u += 7); W--;)M[I++] = B;
                        }
                    }
                    var N = M.subarray(0, S), P = M.subarray(S);
                    m = _t(N), c = _t(P), f = nt(N, m, 1), p = nt(P, c, 1);
                } else T(1);
            } else {
                var k = me(u) + 4, It = t[k - 4] | t[k - 3] << 8, Lt = k + It;
                if (Lt > r) {
                    s && T(0);
                    break;
                }
                a && l(d + It), i.set(t.subarray(k, Lt), d), e.b = d += It, e.p = u = Lt * 8, e.f = h;
                continue;
            }
            if (u > v) {
                s && T(0);
                break;
            }
        }
        a && l(d + 131072);
        for(var $e = (1 << m) - 1, Ve = (1 << c) - 1, kt = u;; kt = u){
            var B = f[vt(t, u) & $e], it = B >> 4;
            if (u += B & 15, u > v) {
                s && T(0);
                break;
            }
            if (B || T(2), it < 256) i[d++] = it;
            else if (it == 256) {
                kt = u, f = null;
                break;
            } else {
                var Kt = it - 254;
                if (it > 264) {
                    var I = it - 257, st = zt[I];
                    Kt = U(t, u, (1 << st) - 1) + Dt[I], u += st;
                }
                var Ot = p[vt(t, u) & Ve], Mt = Ot >> 4;
                Ot || T(3), u += Ot & 15;
                var P = de[Mt];
                if (Mt > 3) {
                    var st = Ft[Mt];
                    P += vt(t, u) & (1 << st) - 1, u += st;
                }
                if (u > v) {
                    s && T(0);
                    break;
                }
                a && l(d + 131072);
                var At = d + Kt;
                if (d < P) {
                    var Xt = o - P, qe = Math.min(P, At);
                    for(Xt + d < 0 && T(3); d < qe; ++d)i[d] = n[Xt + d];
                }
                for(; d < At; d += 4)i[d] = i[d - P], i[d + 1] = i[d + 1 - P], i[d + 2] = i[d + 2 - P], i[d + 3] = i[d + 3 - P];
                d = At;
            }
        }
        e.l = f, e.p = kt, e.b = d, e.f = h, f && (h = 1, e.m = m, e.d = p, e.n = c);
    }while (!h);
    return d == i.length ? i : gt(i, 0, d);
}, He = new x(0), We = function(t, e) {
    var i = {};
    for(var n in t)i[n] = t[n];
    for(var n in e)i[n] = e[n];
    return i;
}, ee = function(t, e, i) {
    for(var n = t(), r = t.toString(), o = r.slice(r.indexOf("[") + 1, r.lastIndexOf("]")).replace(/\s+/g, "").split(","), a = 0; a < n.length; ++a){
        var s = n[a], l = o[a];
        if (typeof s == "function") {
            e += ";" + l + "=";
            var h = s.toString();
            if (s.prototype) {
                if (h.indexOf("[native code]") != -1) {
                    var u = h.indexOf(" ", 8) + 1;
                    e += h.slice(u, h.indexOf("(", u));
                } else {
                    e += h;
                    for(var d in s.prototype)e += ";" + l + ".prototype." + d + "=" + s.prototype[d].toString();
                }
            } else e += h;
        } else i[l] = s;
    }
    return e;
}, mt = [], Ge = function(t) {
    var e = [];
    for(var i in t)t[i].buffer && e.push((t[i] = new t[i].constructor(t[i])).buffer);
    return e;
}, Ke = function(t, e, i, n) {
    if (!mt[i]) {
        for(var r = "", o = {}, a = t.length - 1, s = 0; s < a; ++s)r = ee(t[s], r, o);
        mt[i] = {
            c: ee(t[a], r, o),
            e: o
        };
    }
    var l = We({}, mt[i].e);
    return Be(mt[i].c + ";onmessage=function(e){for(var k in e.data)self[k]=e.data[k];onmessage=" + e.toString() + "}", i, l, Ge(l), n);
}, Xe = function() {
    return [
        x,
        Y,
        se,
        zt,
        Ft,
        le,
        Dt,
        de,
        fe,
        pe,
        yt,
        _e,
        nt,
        _t,
        U,
        vt,
        me,
        gt,
        T,
        ve,
        Ut,
        ye,
        ge
    ];
}, ye = function(t) {
    return postMessage(t, [
        t.buffer
    ]);
}, ge = function(t) {
    return t && {
        out: t.size && new x(t.size),
        dictionary: t.dictionary
    };
}, Qe = function(t, e, i, n, r, o) {
    var a = Ke(i, n, r, function(s, l) {
        a.terminate(), o(s, l);
    });
    return a.postMessage([
        t,
        e
    ], e.consume ? [
        t.buffer
    ] : []), function() {
        a.terminate();
    };
}, G = function(t, e) {
    return t[e] | t[e + 1] << 8;
}, J = function(t, e) {
    return (t[e] | t[e + 1] << 8 | t[e + 2] << 16 | t[e + 3] << 24) >>> 0;
}, Pt = function(t, e) {
    return J(t, e) + J(t, e + 4) * 4294967296;
};
function Ye(t, e, i) {
    return i || (i = e, e = {}), typeof i != "function" && T(7), Qe(t, e, [
        Xe
    ], function(n) {
        return ye(Ut(n.data[0], ge(n.data[1])));
    }, 1, i);
}
function Ut(t, e) {
    return ve(t, {
        i: 2
    }, e && e.out, e && e.dictionary);
}
var Et = typeof TextDecoder < "u" && new TextDecoder, Ze = 0;
try {
    Et.decode(He, {
        stream: !0
    }), Ze = 1;
} catch  {}
var ti = function(t) {
    for(var e = "", i = 0;;){
        var n = t[i++], r = (n > 127) + (n > 223) + (n > 239);
        if (i + r > t.length) return {
            s: e,
            r: gt(t, i - 1)
        };
        r ? r == 3 ? (n = ((n & 15) << 18 | (t[i++] & 63) << 12 | (t[i++] & 63) << 6 | t[i++] & 63) - 65536, e += String.fromCharCode(55296 | n >> 10, 56320 | n & 1023)) : r & 1 ? e += String.fromCharCode((n & 31) << 6 | t[i++] & 63) : e += String.fromCharCode((n & 15) << 12 | (t[i++] & 63) << 6 | t[i++] & 63) : e += String.fromCharCode(n);
    }
};
function rt(t, e) {
    if (e) {
        for(var i = "", n = 0; n < t.length; n += 16384)i += String.fromCharCode.apply(null, t.subarray(n, n + 16384));
        return i;
    } else {
        if (Et) return Et.decode(t);
        var r = ti(t), o = r.s, i = r.r;
        return i.length && T(8), o;
    }
}
var ei = function(t, e) {
    return e + 30 + G(t, e + 26) + G(t, e + 28);
}, ii = function(t, e, i) {
    var n = G(t, e + 28), r = rt(t.subarray(e + 46, e + 46 + n), !(G(t, e + 8) & 2048)), o = e + 46 + n, a = J(t, e + 20), s = i && a == 4294967295 ? ni(t, o) : [
        a,
        J(t, e + 24),
        J(t, e + 42)
    ], l = s[0], h = s[1], u = s[2];
    return [
        G(t, e + 10),
        l,
        h,
        r,
        o + G(t, e + 30) + G(t, e + 32),
        u
    ];
}, ni = function(t, e) {
    for(; G(t, e) != 1; e += 4 + G(t, e + 2));
    return [
        Pt(t, e + 12),
        Pt(t, e + 4),
        Pt(t, e + 20)
    ];
}, ie = typeof queueMicrotask == "function" ? queueMicrotask : typeof setTimeout == "function" ? setTimeout : function(t) {
    t();
};
function ri(t, e, i) {
    i || (i = e, e = {}), typeof i != "function" && T(7);
    var n = [], r = function() {
        for(var v = 0; v < n.length; ++v)n[v]();
    }, o = {}, a = function(v, _) {
        ie(function() {
            i(v, _);
        });
    };
    ie(function() {
        a = i;
    });
    for(var s = t.length - 22; J(t, s) != 101010256; --s)if (!s || t.length - s > 65558) return a(T(13, 0, 1), null), r;
    var l = G(t, s + 8);
    if (l) {
        var h = l, u = J(t, s + 16), d = u == 4294967295 || h == 65535;
        if (d) {
            var f = J(t, s - 12);
            d = J(t, f) == 101075792, d && (h = l = J(t, f + 32), u = J(t, f + 48));
        }
        for(var p = e && e.filter, m = function(v) {
            var _ = ii(t, u, d), S = _[0], y = _[1], E = _[2], M = _[3], D = _[4], I = _[5], F = ei(t, I);
            u = D;
            var j = function(A, k) {
                A ? (r(), a(A, null)) : (k && (o[M] = k), --l || a(null, o));
            };
            if (!p || p({
                name: M,
                size: y,
                originalSize: E,
                compression: S
            })) {
                if (!S) j(null, gt(t, F, F + y));
                else if (S == 8) {
                    var q = t.subarray(F, F + y);
                    if (y < 32e4) try {
                        j(null, Ut(q, {
                            out: new x(E)
                        }));
                    } catch (A) {
                        j(A, null);
                    }
                    else n.push(Ye(q, {
                        size: E
                    }, j));
                } else j(T(14, "unknown compression type " + S, 1), null);
            } else j(null, null);
        }, c = 0; c < h; ++c)m(c);
    } else a(null, {});
    return r;
}
function oi(t) {
    return (Array.isArray(t) ? t : t.issues).reduce((e, i)=>{
        if (i.path) {
            let n = i.path.map(({ key: r })=>r).join(".");
            e.nested[n] = [
                ...e.nested[n] || [],
                i.message
            ];
        } else e.root = [
            ...e.root || [],
            i.message
        ];
        return e;
    }, {
        nested: {}
    });
}
var ai = class extends Error {
    issues;
    constructor(t){
        super(t[0].message), this.name = "ValiError", this.issues = t;
    }
};
function si(t, e) {
    return {
        reason: t == null ? void 0 : t.reason,
        validation: e.validation,
        origin: (t == null ? void 0 : t.origin) || "value",
        message: e.message,
        input: e.input,
        abortEarly: t == null ? void 0 : t.abortEarly,
        abortPipeEarly: t == null ? void 0 : t.abortPipeEarly
    };
}
function li(t, e) {
    return {
        reason: e,
        origin: t == null ? void 0 : t.origin,
        abortEarly: t == null ? void 0 : t.abortEarly,
        abortPipeEarly: t == null ? void 0 : t.abortPipeEarly
    };
}
function Q(t, e, i, n) {
    if (!e || !e.length) return {
        output: t
    };
    let r, o, a = t;
    for (let s of e){
        let l = s(a);
        if (l.issue) {
            r = r || li(i, n);
            let h = si(r, l.issue);
            if (o ? o.push(h) : o = [
                h
            ], r.abortEarly || r.abortPipeEarly) break;
        } else a = l.output;
    }
    return o ? {
        issues: o
    } : {
        output: a
    };
}
function H(t, e) {
    return !t || typeof t == "string" ? [
        t,
        e
    ] : [
        void 0,
        t
    ];
}
function K(t, e, i, n, r, o) {
    return {
        issues: [
            {
                reason: e,
                validation: i,
                origin: (t == null ? void 0 : t.origin) || "value",
                message: n,
                input: r,
                issues: o,
                abortEarly: t == null ? void 0 : t.abortEarly,
                abortPipeEarly: t == null ? void 0 : t.abortPipeEarly
            }
        ]
    };
}
function ui(t = []) {
    return {
        schema: "any",
        async: !1,
        _parse (e, i) {
            return Q(e, t, i, "any");
        }
    };
}
function lt(t, e, i) {
    let [n, r] = H(e, i);
    return {
        schema: "array",
        array: {
            item: t
        },
        async: !1,
        _parse (o, a) {
            if (!Array.isArray(o)) return K(a, "type", "array", n || "Invalid type", o);
            let s, l = [];
            for(let h = 0; h < o.length; h++){
                let u = o[h], d = t._parse(u, a);
                if (d.issues) {
                    let f = {
                        schema: "array",
                        input: o,
                        key: h,
                        value: u
                    };
                    for (let p of d.issues)p.path ? p.path.unshift(f) : p.path = [
                        f
                    ], s == null || s.push(p);
                    if (s || (s = d.issues), a != null && a.abortEarly) break;
                } else l.push(d.output);
            }
            return s ? {
                issues: s
            } : Q(l, r, a, "array");
        }
    };
}
function Ct(t, e) {
    let [i, n] = H(t, e);
    return {
        schema: "boolean",
        async: !1,
        _parse (r, o) {
            return typeof r != "boolean" ? K(o, "type", "boolean", i || "Invalid type", r) : Q(r, n, o, "boolean");
        }
    };
}
function ne(t, e) {
    return {
        schema: "literal",
        literal: t,
        async: !1,
        _parse (i, n) {
            return i !== t ? K(n, "type", "literal", e || "Invalid type", i) : {
                output: i
            };
        }
    };
}
function hi(t, e) {
    return {
        schema: "native_enum",
        nativeEnum: t,
        async: !1,
        _parse (i, n) {
            return Object.values(t).includes(i) ? {
                output: i
            } : K(n, "type", "native_enum", e || "Invalid type", i);
        }
    };
}
function R(t, e) {
    let [i, n] = H(t, e);
    return {
        schema: "number",
        async: !1,
        _parse (r, o) {
            return typeof r != "number" ? K(o, "type", "number", i || "Invalid type", r) : Q(r, n, o, "number");
        }
    };
}
function $(t, e, i) {
    let [n, r] = H(e, i), o;
    return {
        schema: "object",
        object: t,
        async: !1,
        _parse (a, s) {
            if (!a || typeof a != "object") return K(s, "type", "object", n || "Invalid type", a);
            o = o || Object.entries(t);
            let l, h = {};
            for (let [u, d] of o){
                let f = a[u], p = d._parse(f, s);
                if (p.issues) {
                    let m = {
                        schema: "object",
                        input: a,
                        key: u,
                        value: f
                    };
                    for (let c of p.issues)c.path ? c.path.unshift(m) : c.path = [
                        m
                    ], l == null || l.push(c);
                    if (l || (l = p.issues), s != null && s.abortEarly) break;
                } else h[u] = p.output;
            }
            return l ? {
                issues: l
            } : Q(h, r, s, "object");
        }
    };
}
function w(t) {
    return {
        schema: "optional",
        wrapped: t,
        async: !1,
        _parse (e, i) {
            return e === void 0 ? {
                output: e
            } : t._parse(e, i);
        }
    };
}
function C(t, e) {
    let [i, n] = H(t, e);
    return {
        schema: "string",
        async: !1,
        _parse (r, o) {
            return typeof r != "string" ? K(o, "type", "string", i || "Invalid type", r) : Q(r, n, o, "string");
        }
    };
}
function di(t, e, i, n) {
    if (typeof e == "object" && !Array.isArray(e)) {
        let [a, s] = H(i, n);
        return [
            t,
            e,
            a,
            s
        ];
    }
    let [r, o] = H(e, i);
    return [
        C(),
        t,
        r,
        o
    ];
}
var ci = [
    "__proto__",
    "prototype",
    "constructor"
];
function fi(t, e, i, n) {
    let [r, o, a, s] = di(t, e, i, n);
    return {
        schema: "record",
        record: {
            key: r,
            value: o
        },
        async: !1,
        _parse (l, h) {
            if (!l || typeof l != "object") return K(h, "type", "record", a || "Invalid type", l);
            let u, d = {};
            for (let [f, p] of Object.entries(l))if (!ci.includes(f)) {
                let m, c = r._parse(f, {
                    origin: "key",
                    abortEarly: h == null ? void 0 : h.abortEarly,
                    abortPipeEarly: h == null ? void 0 : h.abortPipeEarly
                });
                if (c.issues) {
                    m = {
                        schema: "record",
                        input: l,
                        key: f,
                        value: p
                    };
                    for (let _ of c.issues)_.path = [
                        m
                    ], u == null || u.push(_);
                    if (u || (u = c.issues), h != null && h.abortEarly) break;
                }
                let v = o._parse(p, h);
                if (v.issues) {
                    m = m || {
                        schema: "record",
                        input: l,
                        key: f,
                        value: p
                    };
                    for (let _ of v.issues)_.path ? _.path.unshift(m) : _.path = [
                        m
                    ], u == null || u.push(_);
                    if (u || (u = v.issues), h != null && h.abortEarly) break;
                }
                !c.issues && !v.issues && (d[c.output] = v.output);
            }
            return u ? {
                issues: u
            } : Q(d, s, h, "record");
        }
    };
}
function pi(t, e, i) {
    if (typeof t == "object" && !Array.isArray(t)) {
        let [o, a] = H(e, i);
        return [
            t,
            o,
            a
        ];
    }
    let [n, r] = H(t, e);
    return [
        void 0,
        n,
        r
    ];
}
function re(t, e, i, n) {
    let [r, o, a] = pi(e, i, n);
    return {
        schema: "tuple",
        tuple: {
            items: t,
            rest: r
        },
        async: !1,
        _parse (s, l) {
            if (!Array.isArray(s) || !r && t.length !== s.length || r && t.length > s.length) return K(l, "type", "tuple", o || "Invalid type", s);
            let h, u = [];
            for(let d = 0; d < t.length; d++){
                let f = s[d], p = t[d]._parse(f, l);
                if (p.issues) {
                    let m = {
                        schema: "tuple",
                        input: s,
                        key: d,
                        value: f
                    };
                    for (let c of p.issues)c.path ? c.path.unshift(m) : c.path = [
                        m
                    ], h == null || h.push(c);
                    if (h || (h = p.issues), l != null && l.abortEarly) break;
                } else u[d] = p.output;
            }
            if (r) for(let d = t.length; d < s.length; d++){
                let f = s[d], p = r._parse(f, l);
                if (p.issues) {
                    let m = {
                        schema: "tuple",
                        input: s,
                        key: d,
                        value: f
                    };
                    for (let c of p.issues)c.path ? c.path.unshift(m) : c.path = [
                        m
                    ], h == null || h.push(c);
                    if (h || (h = p.issues), l != null && l.abortEarly) break;
                } else u[d] = p.output;
            }
            return h ? {
                issues: h
            } : Q(u, a, l, "tuple");
        }
    };
}
function Tt(t, e) {
    return {
        schema: "union",
        union: t,
        async: !1,
        _parse (i, n) {
            let r, o;
            for (let a of t){
                let s = a._parse(i, n);
                if (s.issues) {
                    if (r) for (let l of s.issues)r.push(l);
                    else r = s.issues;
                } else {
                    o = [
                        s.output
                    ];
                    break;
                }
            }
            return o ? {
                output: o[0]
            } : K(n, "type", "union", e || "Invalid type", i, r);
        }
    };
}
function ht(t, e, i) {
    let [n, r] = H(e, i);
    return $(t.reduce((o, a)=>({
            ...o,
            ...a.object
        }), {}), n, r);
}
function mi(t, e, i, n) {
    let [r, o] = H(i, n);
    return $(Object.entries(t.object).reduce((a, [s, l])=>e.includes(s) ? a : {
            ...a,
            [s]: l
        }, {}), r, o);
}
function _i(t, e, i) {
    let n = t._parse(e, i);
    return n.issues ? {
        success: !1,
        error: new ai(n.issues),
        issues: n.issues
    } : {
        success: !0,
        data: n.output,
        output: n.output
    };
}
function xt(t, e) {
    return (i)=>i > t ? {
            issue: {
                validation: "max_value",
                message: e || "Invalid value",
                input: i
            }
        } : {
            output: i
        };
}
function jt(t, e) {
    return (i)=>i < t ? {
            issue: {
                validation: "min_value",
                message: e || "Invalid value",
                input: i
            }
        } : {
            output: i
        };
}
var vi = Object.create, $t = Object.defineProperty, yi = Object.getOwnPropertyDescriptor, be = Object.getOwnPropertyNames, gi = Object.getPrototypeOf, bi = Object.prototype.hasOwnProperty, wi = (t, e, i)=>e in t ? $t(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: i
    }) : t[e] = i, dt = (t, e)=>function() {
        return e || (0, t[be(t)[0]])((e = {
            exports: {}
        }).exports, e), e.exports;
    }, Si = (t, e, i, n)=>{
    if (e && typeof e == "object" || typeof e == "function") for (let r of be(e))!bi.call(t, r) && r !== i && $t(t, r, {
        get: ()=>e[r],
        enumerable: !(n = yi(e, r)) || n.enumerable
    });
    return t;
}, Ii = (t, e, i)=>(i = t != null ? vi(gi(t)) : {}, Si(e || !t || !t.__esModule ? $t(i, "default", {
        value: t,
        enumerable: !0
    }) : i, t)), Li = (t, e, i)=>(wi(t, typeof e != "symbol" ? e + "" : e, i), i), ki = dt({
    "../../node_modules/.pnpm/@rgba-image+copy@0.1.3/node_modules/@rgba-image/copy/dist/index.js" (t) {
        Object.defineProperty(t, "__esModule", {
            value: !0
        }), t.copy = void 0;
        var e = (i, n, r = 0, o = 0, a = i.width - r, s = i.height - o, l = 0, h = 0)=>{
            if (r = r | 0, o = o | 0, a = a | 0, s = s | 0, l = l | 0, h = h | 0, a <= 0 || s <= 0) return;
            let u = new Uint32Array(i.data.buffer), d = new Uint32Array(n.data.buffer);
            for(let f = 0; f < s; f++){
                let p = o + f;
                if (p < 0 || p >= i.height) continue;
                let m = h + f;
                if (!(m < 0 || m >= n.height)) for(let c = 0; c < a; c++){
                    let v = r + c;
                    if (v < 0 || v >= i.width) continue;
                    let _ = l + c;
                    if (_ < 0 || _ >= n.width) continue;
                    let S = p * i.width + v, y = m * n.width + _;
                    d[y] = u[S];
                }
            }
        };
        t.copy = e;
    }
}), Oi = dt({
    "../../node_modules/.pnpm/@rgba-image+create-image@0.1.1/node_modules/@rgba-image/create-image/dist/index.js" (t) {
        Object.defineProperty(t, "__esModule", {
            value: !0
        }), t.CreateImageFactory = (e = [
            0,
            0,
            0,
            0
        ], i = 4)=>{
            if (i = Math.floor(i), isNaN(i) || i < 1) throw TypeError("channels should be a positive non-zero number");
            if (!("length" in e) || e.length < i) throw TypeError(`fill should be iterable with at least ${i} members`);
            e = new Uint8ClampedArray(e).slice(0, i);
            let n = e.every((r)=>r === 0);
            return (r, o, a)=>{
                if (r === void 0 || o === void 0) throw TypeError("Not enough arguments");
                if (r = Math.floor(r), o = Math.floor(o), isNaN(r) || r < 1 || isNaN(o) || o < 1) throw TypeError("Index or size is negative or greater than the allowed amount");
                let s = r * o * i;
                if (a === void 0 && (a = new Uint8ClampedArray(s)), a instanceof Uint8ClampedArray) {
                    if (a.length !== s) throw TypeError("Index or size is negative or greater than the allowed amount");
                    if (!n) for(let l = 0; l < o; l++)for(let h = 0; h < r; h++){
                        let u = (l * r + h) * i;
                        for(let d = 0; d < i; d++)a[u + d] = e[d];
                    }
                    return {
                        get width () {
                            return r;
                        },
                        get height () {
                            return o;
                        },
                        get data () {
                            return a;
                        }
                    };
                }
                throw TypeError("Expected data to be Uint8ClampedArray or undefined");
            };
        }, t.createImage = t.CreateImageFactory();
    }
}), Mi = dt({
    "../../node_modules/.pnpm/@rgba-image+lanczos@0.1.1/node_modules/@rgba-image/lanczos/dist/filters.js" (t) {
        Object.defineProperty(t, "__esModule", {
            value: !0
        }), t.filters = void 0;
        var e = 14, i = (o, a)=>{
            if (o <= -a || o >= a || o == 0) return 0;
            let s = o * Math.PI;
            return Math.sin(s) / s * Math.sin(s / a) / (s / a);
        }, n = (o)=>Math.round(o * ((1 << e) - 1)), r = (o, a, s, l, h)=>{
            let u = h ? 2 : 3, d = 1 / s, f = Math.min(1, s), p = u / f, m = Math.floor((p + 1) * 2), c = new Int16Array((m + 2) * a), v = 0;
            for(let _ = 0; _ < a; _++){
                let S = (_ + .5) * d + l, y = Math.max(0, Math.floor(S - p)), E = Math.min(o - 1, Math.ceil(S + p)), M = E - y + 1, D = new Float32Array(M), I = new Int16Array(M), F = 0, j = 0;
                for(let N = y; N <= E; N++){
                    let P = i((N + .5 - S) * f, u);
                    F += P, D[j] = P, j++;
                }
                let q = 0;
                for(let N = 0; N < D.length; N++){
                    let P = D[N] / F;
                    q += P, I[N] = n(P);
                }
                I[a >> 1] += n(1 - q);
                let A = 0;
                for(; A < I.length && I[A] === 0;)A++;
                let k = I.length - 1;
                for(; k > 0 && I[k] === 0;)k--;
                let B = y + A, W = k - A + 1;
                c[v++] = B, c[v++] = W, c.set(I.subarray(A, k + 1), v), v += W;
            }
            return c;
        };
        t.filters = r;
    }
}), Ai = dt({
    "../../node_modules/.pnpm/@rgba-image+lanczos@0.1.1/node_modules/@rgba-image/lanczos/dist/convolve.js" (t) {
        Object.defineProperty(t, "__esModule", {
            value: !0
        }), t.convolve = void 0;
        var e = 14, i = (n, r, o, a, s, l)=>{
            let h = 0, u = 0;
            for(let d = 0; d < a; d++){
                let f = 0;
                for(let p = 0; p < s; p++){
                    let m = l[f++], c = h + m * 4 | 0, v = 0, _ = 0, S = 0, y = 0;
                    for(let E = l[f++]; E > 0; E--){
                        let M = l[f++];
                        v = v + M * n[c] | 0, _ = _ + M * n[c + 1] | 0, S = S + M * n[c + 2] | 0, y = y + M * n[c + 3] | 0, c = c + 4 | 0;
                    }
                    r[u] = v + 8192 >> e, r[u + 1] = _ + 8192 >> e, r[u + 2] = S + 8192 >> e, r[u + 3] = y + 8192 >> e, u = u + a * 4 | 0;
                }
                u = (d + 1) * 4 | 0, h = (d + 1) * o * 4 | 0;
            }
        };
        t.convolve = i;
    }
}), Pi = dt({
    "../../node_modules/.pnpm/@rgba-image+lanczos@0.1.1/node_modules/@rgba-image/lanczos/dist/index.js" (t) {
        Object.defineProperty(t, "__esModule", {
            value: !0
        }), t.lanczos2 = t.lanczos = void 0;
        var e = ki(), i = Oi(), n = Mi(), r = Ai(), o = (l, h, u = !1)=>{
            let d = h.width / l.width, f = h.height / l.height, p = n.filters(l.width, h.width, d, 0, u), m = n.filters(l.height, h.height, f, 0, u), c = new Uint8ClampedArray(h.width * l.height * 4);
            r.convolve(l.data, c, l.width, l.height, h.width, p), r.convolve(c, h.data, l.height, h.width, h.height, m);
        }, a = (l, h, u = 0, d = 0, f = l.width - u, p = l.height - d, m = 0, c = 0, v = h.width - m, _ = h.height - c)=>{
            if (u = u | 0, d = d | 0, f = f | 0, p = p | 0, m = m | 0, c = c | 0, v = v | 0, _ = _ | 0, f <= 0 || p <= 0 || v <= 0 || _ <= 0) return;
            if (u === 0 && d === 0 && f === l.width && p === l.height && m === 0 && c === 0 && v === h.width && _ === h.height) {
                o(l, h);
                return;
            }
            let S = i.createImage(f, p), y = i.createImage(v, _);
            e.copy(l, S, u, d), o(S, y), e.copy(y, h, 0, 0, y.width, y.height, m, c);
        };
        t.lanczos = a;
        var s = (l, h, u = 0, d = 0, f = l.width - u, p = l.height - d, m = 0, c = 0, v = h.width - m, _ = h.height - c)=>{
            if (u = u | 0, d = d | 0, f = f | 0, p = p | 0, m = m | 0, c = c | 0, v = v | 0, _ = _ | 0, f <= 0 || p <= 0 || v <= 0 || _ <= 0) return;
            if (u === 0 && d === 0 && f === l.width && p === l.height && m === 0 && c === 0 && v === h.width && _ === h.height) {
                o(l, h, !0);
                return;
            }
            let S = i.createImage(f, p), y = i.createImage(v, _);
            e.copy(l, S, u, d), o(S, y, !0), e.copy(y, h, 0, 0, y.width, y.height, m, c);
        };
        t.lanczos2 = s;
    }
}), we = ((t)=>(t.Bounce = "bounce", t.Normal = "normal", t))(we || {}), Ci = hi(we), Se = $({
    autoplay: w(Ct()),
    defaultTheme: w(C()),
    direction: w(Tt([
        ne(1),
        ne(-1)
    ])),
    hover: w(Ct()),
    id: C(),
    intermission: w(R()),
    loop: w(Tt([
        Ct(),
        R()
    ])),
    playMode: w(Ci),
    speed: w(R()),
    themeColor: w(C())
}), Ei = $({
    animations: lt(C()),
    id: C()
}), Ti = $({
    activeAnimationId: w(C()),
    animations: lt(Se),
    author: w(C()),
    custom: w(fi(C(), ui())),
    description: w(C()),
    generator: w(C()),
    keywords: w(C()),
    revision: w(R()),
    themes: w(lt(Ei)),
    states: w(lt(C())),
    version: w(C())
}), Vt = mi(Se, [
    "id"
]), Z = $({
    state: C()
}), xi = Z, ji = ht([
    Z,
    $({
        ms: R()
    })
]), Ni = ht([
    Z,
    $({
        count: R()
    })
]), zi = Z, Fi = Z, Di = Z, Ui = ht([
    Z,
    $({
        threshold: w(lt(R([
            jt(0),
            xt(1)
        ])))
    })
]), $i = $({
    onAfter: w(ji),
    onClick: w(xi),
    onComplete: w(Di),
    onEnter: w(Ni),
    onMouseEnter: w(zi),
    onMouseLeave: w(Fi),
    onShow: w(Ui)
}), Vi = ht([
    Vt,
    $({
        playOnScroll: w(re([
            R([
                jt(0),
                xt(1)
            ]),
            R([
                jt(0),
                xt(1)
            ])
        ])),
        segments: w(Tt([
            re([
                R(),
                R()
            ]),
            C()
        ]))
    })
]);
ht([
    $i,
    $({
        animationId: w(C()),
        playbackSettings: Vi
    })
]);
var qi = {
    jpeg: "image/jpeg",
    png: "image/png",
    gif: "image/gif",
    bmp: "image/bmp",
    svg: "image/svg+xml",
    webp: "image/webp",
    mpeg: "audio/mpeg",
    mp3: "audio/mp3"
}, oe = {
    jpeg: [
        255,
        216,
        255
    ],
    png: [
        137,
        80,
        78,
        71,
        13,
        10,
        26,
        10
    ],
    gif: [
        71,
        73,
        70
    ],
    bmp: [
        66,
        77
    ],
    webp: [
        82,
        73,
        70,
        70,
        87,
        69,
        66,
        80
    ],
    svg: [
        60,
        63,
        120
    ],
    mp3: [
        73,
        68,
        51,
        3,
        0,
        0,
        0,
        0
    ],
    mpeg: [
        73,
        68,
        51,
        3,
        0,
        0,
        0,
        0
    ]
}, Bi = (t)=>{
    let e = null, i = [];
    if (!t) return null;
    let n = t.substring(t.indexOf(",") + 1);
    typeof window > "u" ? e = $4a739abef963ef65$require$Buffer.from(n, "base64").toString("binary") : e = atob(n);
    let r = new Uint8Array(e.length);
    for(let o = 0; o < e.length; o += 1)r[o] = e.charCodeAt(o);
    i = Array.from(r.subarray(0, 8));
    for(let o in oe){
        let a = oe[o];
        if (a && i.every((s, l)=>s === a[l])) return qi[o];
    }
    return null;
}, qt = class extends Error {
    constructor(t, e){
        super(t), Li(this, "code"), this.name = "[dotlottie-js]", this.code = e;
    }
};
function Ie(t) {
    let e;
    if (typeof window > "u") e = $4a739abef963ef65$require$Buffer.from(t).toString("base64");
    else {
        let i = Array.prototype.map.call(t, (n)=>String.fromCharCode(n)).join("");
        e = window.btoa(i);
    }
    return `data:${Bi(e)};base64,${e}`;
}
function ae(t) {
    return "w" in t && "h" in t && !("xt" in t) && "p" in t;
}
function Nt(t) {
    return !("h" in t) && !("w" in t) && "p" in t && "e" in t && "u" in t && "id" in t;
}
async function ct(t, e = ()=>!0) {
    if (!(t instanceof Uint8Array)) throw new qt("DotLottie not found", "INVALID_DOTLOTTIE");
    return await new Promise((i, n)=>{
        ri(t, {
            filter: e
        }, (r, o)=>{
            r && n(r), i(o);
        });
    });
}
async function Bt(t, e, i) {
    if (!(t instanceof Uint8Array)) throw new qt("DotLottie not found", "INVALID_DOTLOTTIE");
    return (await ct(t, (n)=>n.name === e && (!i || i(n))))[e];
}
async function bt(t) {
    let e = "manifest.json", i = (await ct(t, (n)=>n.name === e))[e];
    if (!(typeof i > "u")) return JSON.parse(rt(i, !1));
}
async function Ji(t) {
    if (!(t instanceof Uint8Array)) return {
        success: !1,
        error: "DotLottie not found"
    };
    let e = await bt(t);
    if (typeof e > "u") return {
        success: !1,
        error: "Invalid .lottie file, manifest.json is missing"
    };
    let i = _i(Ti, e);
    return i.success ? {
        success: !0
    } : {
        success: !1,
        error: `Invalid .lottie file, manifest.json structure is invalid, ${JSON.stringify(oi(i.error).nested, null, 2)}`
    };
}
async function Jt(t) {
    let e = new Uint8Array(t), i = await Ji(e);
    if (i.error) throw new qt(i.error, "INVALID_DOTLOTTIE");
    return e;
}
async function Ri(t, e) {
    let i = await ct(t, (r)=>{
        let o = r.name.replace("audio/", "");
        return r.name.startsWith("audio/") && (!e || e({
            ...r,
            name: o
        }));
    }), n = {};
    for(let r in i){
        let o = i[r];
        if (o instanceof Uint8Array) {
            let a = r.replace("audio/", "");
            n[a] = Ie(o);
        }
    }
    return n;
}
async function Hi(t, e) {
    var i;
    let n = new Map;
    for (let [o, a] of Object.entries(e))for (let s of a.assets || [])if (Nt(s)) {
        let l = s.p;
        n.has(l) || n.set(l, new Set), (i = n.get(l)) == null || i.add(o);
    }
    let r = await Ri(t, (o)=>n.has(o.name));
    for (let [o, a] of n){
        let s = r[o];
        if (s) for (let l of a){
            let h = e[l];
            for (let u of (h == null ? void 0 : h.assets) || [])Nt(u) && u.p === o && (u.p = s, u.u = "", u.e = 1);
        }
    }
}
async function Wi(t, e) {
    let i = await ct(t, (r)=>{
        let o = r.name.replace("images/", "");
        return r.name.startsWith("images/") && (!e || e({
            ...r,
            name: o
        }));
    }), n = {};
    for(let r in i){
        let o = i[r];
        if (o instanceof Uint8Array) {
            let a = r.replace("images/", "");
            n[a] = Ie(o);
        }
    }
    return n;
}
async function Gi(t, e) {
    var i;
    let n = new Map;
    for (let [o, a] of Object.entries(e))for (let s of a.assets || [])if (ae(s)) {
        let l = s.p;
        n.has(l) || n.set(l, new Set), (i = n.get(l)) == null || i.add(o);
    }
    let r = await Wi(t, (o)=>n.has(o.name));
    for (let [o, a] of n){
        let s = r[o];
        if (s) for (let l of a){
            let h = e[l];
            for (let u of (h == null ? void 0 : h.assets) || [])ae(u) && u.p === o && (u.p = s, u.u = "", u.e = 1);
        }
    }
}
async function Le(t, e, { inlineAssets: i } = {}, n) {
    let r = `animations/${e}.json`, o = await Bt(t, r, n);
    if (typeof o > "u") return;
    let a = JSON.parse(rt(o, !1));
    if (!i) return a;
    let s = {
        [e]: a
    };
    return await Gi(t, s), await Hi(t, s), a;
}
async function ke(t, e, i) {
    let n = `themes/${e}.lss`, r = await Bt(t, n, i);
    if (!(typeof r > "u")) return rt(r, !1);
}
async function Oe(t, e) {
    let i = {}, n = await ct(t, (r)=>{
        let o = r.name.replace("states/", "").replace(".json", "");
        return r.name.startsWith("states/") && (!e || e({
            ...r,
            name: o
        }));
    });
    for(let r in n){
        let o = n[r];
        if (o instanceof Uint8Array) {
            let a = r.replace("states/", "").replace(".json", "");
            i[a] = rt(o, !1);
        }
    }
    return i;
}
async function Me(t, e, i) {
    let n = `states/${e}.json`, r = await Bt(t, n, i);
    return typeof r > "u" ? void 0 : JSON.parse(rt(r, !1));
}
Ii(Pi());
function g(t, e = "dotLottie-common") {
    return new Error(`[${e}]: ${t}`);
}
function tt(t, e = "dotLottie-common", ...i) {
    console.error(`[${e}]:`, t, ...i);
}
function L(t, e = "dotLottie-common", ...i) {
    console.warn(`[${e}]:`, t, ...i);
}
function Ae(t = "") {
    let e = t.trim(), i = e.lastIndexOf("/"), n = e.substring(i + 1), r = n.indexOf(".");
    return r !== -1 ? n.substring(0, r) : n;
}
function ot(t) {
    return [
        "v",
        "ip",
        "op",
        "layers",
        "fr",
        "w",
        "h"
    ].every((e)=>Object.prototype.hasOwnProperty.call(t, e));
}
function Pe(t) {
    let e = t.assets;
    return e ? e.some((i)=>Nt(i)) : !1;
}
function Ce(t) {
    try {
        let e = JSON.parse(t);
        return ot(e);
    } catch  {
        return !1;
    }
}
function rn(t, e) {
    let i = Object.keys(t).find((n)=>t[n] === e);
    if (i === void 0) throw new Error("Value not found in the object.");
    return i;
}
function Rt(t) {
    return JSON.parse(JSON.stringify(t));
}
var Ee = class {
    _dotLottie;
    _animationsMap = new Map;
    _themeMap = new Map;
    _stateMachinesMap = new Map;
    _manifest;
    get dotLottie() {
        return this._dotLottie;
    }
    get animationsMap() {
        return this._animationsMap;
    }
    get themeMap() {
        return this._themeMap;
    }
    get stateMachinesMap() {
        return this._stateMachinesMap;
    }
    get manifest() {
        return this._manifest;
    }
    async loadFromUrl(t) {
        let e = await fetch(t, {
            method: "GET",
            mode: "cors"
        });
        if (!e.ok) throw new Error(`Failed to load dotLottie from ${t} with status ${e.status}`);
        let i = e.headers.get("content-type");
        if (i != null && i.includes("application/json")) {
            let n = await e.json();
            if (!ot(n)) throw new Error(`Invalid lottie JSON at ${t}`);
            let r = Ae(t);
            this._animationsMap.set(r, n);
            let o = {
                activeAnimationId: r,
                animations: [
                    {
                        id: r
                    }
                ]
            };
            this._manifest = o;
        } else {
            this._dotLottie = await Jt(await e.arrayBuffer());
            let n = await bt(this._dotLottie);
            if (!n) throw new Error("Manifest not found");
            this._manifest = n;
        }
    }
    loadFromLottieJSON(t) {
        if (!ot(t)) throw new Error("Invalid lottie JSON");
        let e = "my-animation";
        this._animationsMap.set(e, t);
        let i = {
            activeAnimationId: e,
            animations: [
                {
                    id: e
                }
            ]
        };
        this._manifest = i;
    }
    async loadFromArrayBuffer(t) {
        this._dotLottie = await Jt(t);
        let e = await bt(this._dotLottie);
        if (!e) throw new Error("Manifest not found");
        this._manifest = e;
    }
    async getAnimation(t) {
        if (this._animationsMap.get(t)) return this._animationsMap.get(t);
        if (!this._dotLottie) return;
        let e = await Le(this._dotLottie, t, {
            inlineAssets: !0
        });
        return e && this._animationsMap.set(t, e), e;
    }
    async getTheme(t) {
        if (this._themeMap.get(t)) return this._themeMap.get(t);
        if (!this._dotLottie) return;
        let e = await ke(this._dotLottie, t);
        return e && this._themeMap.set(t, e), e;
    }
    async getStateMachines() {
        if (!this._dotLottie) return;
        let t = await Oe(this._dotLottie);
        for(let e in t)if (e) {
            let i = t[e];
            if (i) {
                let n = JSON.parse(i);
                if (n) {
                    let r = n.descriptor.id;
                    this._stateMachinesMap.get(r) || this._stateMachinesMap.set(r, n);
                }
            }
        }
        return Array.from(this._stateMachinesMap.values());
    }
    async getStateMachine(t) {
        if (this._stateMachinesMap.get(t)) return this._stateMachinesMap.get(t);
        if (!this._dotLottie) return;
        let e = await Me(this._dotLottie, t);
        return e && this._stateMachinesMap.set(e.descriptor.id, e), e;
    }
};


async function Te(t, e) {
    let [{ relottie: i }, { default: n }] = await Promise.all([
        (parcelRequire("XwHZu")),
        (parcelRequire("iVO9V"))
    ]), r = await i().use(n, {
        lss: e
    }).process(JSON.stringify(t));
    return JSON.parse(r.value);
}
function St() {
    throw new Error("Cycle detected");
}
function Wt() {
    if (at > 1) at--;
    else {
        for(var t, e = !1; ft !== void 0;){
            var i = ft;
            for(ft = void 0, Ht++; i !== void 0;){
                var n = i.o;
                if (i.o = void 0, i.f &= -3, !(8 & i.f) && je(i)) try {
                    i.c();
                } catch (r) {
                    e || (t = r, e = !0);
                }
                i = n;
            }
        }
        if (Ht = 0, at--, e) throw t;
    }
}
var O = void 0, ft = void 0, at = 0, Ht = 0, wt = 0;
function xe(t) {
    if (O !== void 0) {
        var e = t.n;
        if (e === void 0 || e.t !== O) return e = {
            i: 0,
            S: t,
            p: O.s,
            n: void 0,
            t: O,
            e: void 0,
            x: void 0,
            r: e
        }, O.s !== void 0 && (O.s.n = e), O.s = e, t.n = e, 32 & O.f && t.S(e), e;
        if (e.i === -1) return e.i = 0, e.n !== void 0 && (e.n.p = e.p, e.p !== void 0 && (e.p.n = e.n), e.p = O.s, e.n = void 0, O.s.n = e, O.s = e), e;
    }
}
function z(t) {
    this.v = t, this.i = 0, this.n = void 0, this.t = void 0;
}
z.prototype.h = function() {
    return !0;
};
z.prototype.S = function(t) {
    this.t !== t && t.e === void 0 && (t.x = this.t, this.t !== void 0 && (this.t.e = t), this.t = t);
};
z.prototype.U = function(t) {
    if (this.t !== void 0) {
        var e = t.e, i = t.x;
        e !== void 0 && (e.x = i, t.e = void 0), i !== void 0 && (i.e = e, t.x = void 0), t === this.t && (this.t = i);
    }
};
z.prototype.subscribe = function(t) {
    var e = this;
    return Qi(function() {
        var i = e.value, n = 32 & this.f;
        this.f &= -33;
        try {
            t(i);
        } finally{
            this.f |= n;
        }
    });
};
z.prototype.valueOf = function() {
    return this.value;
};
z.prototype.toString = function() {
    return this.value + "";
};
z.prototype.toJSON = function() {
    return this.value;
};
z.prototype.peek = function() {
    return this.v;
};
Object.defineProperty(z.prototype, "value", {
    get: function() {
        var t = xe(this);
        return t !== void 0 && (t.i = this.i), this.v;
    },
    set: function(t) {
        if (O instanceof et && function() {
            throw new Error("Computed cannot have side-effects");
        }(), t !== this.v) {
            Ht > 100 && St(), this.v = t, this.i++, wt++, at++;
            try {
                for(var e = this.t; e !== void 0; e = e.x)e.t.N();
            } finally{
                Wt();
            }
        }
    }
});
function Ki(t) {
    return new z(t);
}
function je(t) {
    for(var e = t.s; e !== void 0; e = e.n)if (e.S.i !== e.i || !e.S.h() || e.S.i !== e.i) return !0;
    return !1;
}
function Ne(t) {
    for(var e = t.s; e !== void 0; e = e.n){
        var i = e.S.n;
        if (i !== void 0 && (e.r = i), e.S.n = e, e.i = -1, e.n === void 0) {
            t.s = e;
            break;
        }
    }
}
function ze(t) {
    for(var e = t.s, i = void 0; e !== void 0;){
        var n = e.p;
        e.i === -1 ? (e.S.U(e), n !== void 0 && (n.n = e.n), e.n !== void 0 && (e.n.p = n)) : i = e, e.S.n = e.r, e.r !== void 0 && (e.r = void 0), e = n;
    }
    t.s = i;
}
function et(t) {
    z.call(this, void 0), this.x = t, this.s = void 0, this.g = wt - 1, this.f = 4;
}
(et.prototype = new z).h = function() {
    if (this.f &= -3, 1 & this.f) return !1;
    if ((36 & this.f) == 32 || (this.f &= -5, this.g === wt)) return !0;
    if (this.g = wt, this.f |= 1, this.i > 0 && !je(this)) return this.f &= -2, !0;
    var t = O;
    try {
        Ne(this), O = this;
        var e = this.x();
        (16 & this.f || this.v !== e || this.i === 0) && (this.v = e, this.f &= -17, this.i++);
    } catch (i) {
        this.v = i, this.f |= 16, this.i++;
    }
    return O = t, ze(this), this.f &= -2, !0;
};
et.prototype.S = function(t) {
    if (this.t === void 0) {
        this.f |= 36;
        for(var e = this.s; e !== void 0; e = e.n)e.S.S(e);
    }
    z.prototype.S.call(this, t);
};
et.prototype.U = function(t) {
    if (this.t !== void 0 && (z.prototype.U.call(this, t), this.t === void 0)) {
        this.f &= -33;
        for(var e = this.s; e !== void 0; e = e.n)e.S.U(e);
    }
};
et.prototype.N = function() {
    if (!(2 & this.f)) {
        this.f |= 6;
        for(var t = this.t; t !== void 0; t = t.x)t.t.N();
    }
};
et.prototype.peek = function() {
    if (this.h() || St(), 16 & this.f) throw this.v;
    return this.v;
};
Object.defineProperty(et.prototype, "value", {
    get: function() {
        1 & this.f && St();
        var t = xe(this);
        if (this.h(), t !== void 0 && (t.i = this.i), 16 & this.f) throw this.v;
        return this.v;
    }
});
function Fe(t) {
    var e = t.u;
    if (t.u = void 0, typeof e == "function") {
        at++;
        var i = O;
        O = void 0;
        try {
            e();
        } catch (n) {
            throw t.f &= -2, t.f |= 8, Gt(t), n;
        } finally{
            O = i, Wt();
        }
    }
}
function Gt(t) {
    for(var e = t.s; e !== void 0; e = e.n)e.S.U(e);
    t.x = void 0, t.s = void 0, Fe(t);
}
function Xi(t) {
    if (O !== this) throw new Error("Out-of-order effect");
    ze(this), O = t, this.f &= -2, 8 & this.f && Gt(this), Wt();
}
function pt(t) {
    this.x = t, this.u = void 0, this.s = void 0, this.o = void 0, this.f = 32;
}
pt.prototype.c = function() {
    var t = this.S();
    try {
        if (8 & this.f || this.x === void 0) return;
        var e = this.x();
        typeof e == "function" && (this.u = e);
    } finally{
        t();
    }
};
pt.prototype.S = function() {
    1 & this.f && St(), this.f |= 1, this.f &= -9, Fe(this), Ne(this), at++;
    var t = O;
    return O = this, Xi.bind(this, t);
};
pt.prototype.N = function() {
    2 & this.f || (this.f |= 2, this.o = ft, ft = this);
};
pt.prototype.d = function() {
    this.f |= 8, 1 & this.f || Gt(this);
};
function Qi(t) {
    var e = new pt(t);
    try {
        e.c();
    } catch (i) {
        throw e.d(), i;
    }
    return e.d.bind(e);
}
var De = class {
    _state;
    _prevState;
    constructor(t){
        this._prevState = t, this._state = Ki(t);
    }
    setState(t) {
        this._prevState = this._state.value, this._state.value = t;
    }
    subscribe(t) {
        return this._state.subscribe((e)=>t(e, this._prevState));
    }
};

async function Ue(t, e) {
    let [{ DotLottieStateMachineManager: i }] = await Promise.all([
        (parcelRequire("9j6Ub"))
    ]);
    if (!t.length) throw g("No state machines available inside this .lottie!");
    return new i(t, e);
}
var Yi = {
    name: "@dotlottie/common",
    version: "0.7.6",
    type: "module",
    description: "",
    author: "Afsal <afsal@lottiefiles.com>, Sam Osborne <sam@lottiefiles.com>",
    license: "MIT",
    engines: {
        node: ">18.0.0"
    },
    module: "dist/index.js",
    main: "dist/index.js",
    types: "dist/index.d.ts",
    files: [
        "dist"
    ],
    keywords: [],
    scripts: {
        build: "tsup",
        dev: "tsup --watch",
        lint: "eslint .",
        "type-check": "tsc --noEmit"
    },
    dependencies: {
        "@dotlottie/dotlottie-js": "0.6.0",
        "@lottiefiles/relottie": "1.0.0",
        "@lottiefiles/relottie-style": "0.4.3",
        "@preact/signals-core": "^1.2.3",
        howler: "^2.2.3",
        "lottie-web": "^5.12.2",
        xstate: "^4.38.1"
    },
    devDependencies: {
        "@lottiefiles/lottie-types": "^1.2.0",
        "@types/howler": "^2.2.8",
        tsup: "^7.2.0",
        typescript: "^4.7.4"
    },
    publishConfig: {
        access: "public"
    }
}, Zi = ((t)=>(t.Complete = "complete", t.DataFail = "data_fail", t.DataReady = "data_ready", t.Error = "error", t.Frame = "frame", t.Freeze = "freeze", t.LoopComplete = "loopComplete", t.Pause = "pause", t.Play = "play", t.Ready = "ready", t.Stop = "stop", t.VisibilityChange = "visibilityChange", t))(Zi || {}), tn = ((t)=>(t.Completed = "completed", t.Error = "error", t.Fetching = "fetching", t.Frozen = "frozen", t.Initial = "initial", t.Loading = "loading", t.Paused = "paused", t.Playing = "playing", t.Ready = "ready", t.Stopped = "stopped", t))(tn || {}), en = ((t)=>(t.Bounce = "bounce", t.Normal = "normal", t))(en || {}), V = {
    autoplay: !1,
    direction: 1,
    hover: !1,
    intermission: 0,
    loop: !1,
    playMode: "normal",
    speed: 1,
    defaultTheme: ""
}, nn = {
    activeStateId: "",
    autoplay: !1,
    currentState: "initial",
    frame: 0,
    seeker: 0,
    direction: 1,
    hover: !1,
    loop: !1,
    playMode: "normal",
    speed: 1,
    background: "transparent",
    intermission: 0,
    currentAnimationId: void 0,
    visibilityPercentage: 0
};








var wn = class {
    _lottie;
    _src;
    _animationConfig;
    _prevUserPlaybackOptions = {};
    _userPlaybackOptions;
    _hover = !1;
    _loop = !1;
    _counter = 0;
    _intermission = 0;
    _counterInterval = null;
    _container = null;
    _name;
    _mode = "normal";
    _background = "transparent";
    _animation;
    _defaultTheme;
    _activeAnimationId;
    _currentAnimationId;
    _testId;
    _listeners = new Map;
    _currentState = "initial";
    _stateBeforeFreeze = "initial";
    state = new De(nn);
    _light = !1;
    _worker = !1;
    _dotLottieLoader = new Ee;
    _activeStateId;
    _inInteractiveMode = !1;
    _scrollTicking = !1;
    _scrollCallback = void 0;
    _onShowIntersectionObserver = void 0;
    _visibilityPercentage = 0;
    _audios = [];
    _stateMachineManager;
    constructor(t, e, i){
        typeof t == "string" ? this._src = t : this._src = Rt(t), i != null && i.testId && (this._testId = i.testId), this._defaultTheme = (i == null ? void 0 : i.defaultTheme) || "", this._userPlaybackOptions = this._validatePlaybackOptions(i || {}), typeof (i == null ? void 0 : i.activeAnimationId) == "string" && (this._activeAnimationId = i.activeAnimationId), this._container = e || null, typeof (i == null ? void 0 : i.background) == "string" && this.setBackground(i.background), typeof (i == null ? void 0 : i.activeStateId) < "u" && (this._activeStateId = i.activeStateId);
        let { rendererSettings: n, ...r } = i || {};
        this._animationConfig = {
            loop: !1,
            autoplay: !1,
            renderer: "svg",
            rendererSettings: {
                clearCanvas: !0,
                progressiveLoad: !0,
                hideOnTransparent: !0,
                filterSize: {
                    width: "200%",
                    height: "200%",
                    x: "-50%",
                    y: "-50%"
                },
                ...n
            },
            ...r
        }, i != null && i.light && (this._light = i.light), i != null && i.worker && (this._worker = i.worker), this._listenToHover(), this._listenToVisibilityChange();
    }
    _listenToHover() {
        var t, e, i, n;
        let r = ()=>{
            this._hover && this.currentState !== "playing" && this.play();
        }, o = ()=>{
            this._hover && this.currentState === "playing" && this.stop();
        };
        (t = this._container) == null || t.removeEventListener("mouseenter", r), (e = this._container) == null || e.removeEventListener("mouseleave", o), (i = this._container) == null || i.addEventListener("mouseleave", o), (n = this._container) == null || n.addEventListener("mouseenter", r);
    }
    _onVisibilityChange() {
        !this._lottie || typeof document > "u" || (document.hidden && this.currentState === "playing" ? this.freeze() : this.currentState === "frozen" && this.unfreeze());
    }
    _listenToVisibilityChange() {
        typeof document < "u" && typeof document.hidden < "u" && document.addEventListener("visibilitychange", ()=>this._onVisibilityChange());
    }
    _getOption(t) {
        var e;
        if (typeof this._userPlaybackOptions[t] < "u") return this._userPlaybackOptions[t];
        let i = (e = this._dotLottieLoader.manifest) == null ? void 0 : e.animations.find((n)=>n.id === this._currentAnimationId);
        return i && typeof i[t] < "u" ? i[t] : V[t];
    }
    _getPlaybackOptions() {
        let t = {};
        for(let e in V)typeof V[e] < "u" && (t[e] = this._getOption(e));
        return t;
    }
    _setPlayerState(t) {
        var e, i, n;
        let r = t(this._getPlaybackOptions());
        try {
            Vt._parse(r);
        } catch  {
            L(`Invalid PlaybackOptions, ${JSON.stringify(r, null, 2)}`);
            return;
        }
        typeof r.defaultTheme < "u" && (this._defaultTheme = r.defaultTheme), typeof r.playMode < "u" && (this._mode = r.playMode), typeof r.intermission < "u" && (this._intermission = r.intermission), typeof r.hover < "u" && (this._hover = r.hover), typeof r.loop < "u" && (this.clearCountTimer(), this._loop = r.loop, this._counter = 0, (e = this._lottie) == null || e.setLoop(typeof r.loop == "number" ? !0 : r.loop)), typeof r.speed < "u" && ((i = this._lottie) == null || i.setSpeed(r.speed)), typeof r.autoplay < "u" && this._lottie && (this._lottie.autoplay = r.autoplay), typeof r.direction < "u" && ((n = this._lottie) == null || n.setDirection(r.direction));
    }
    _getOptionsFromAnimation(t) {
        let { id: e, ...i } = t;
        return {
            ...V,
            ...i
        };
    }
    _updateTestData() {
        !this._testId || !this._lottie || (window.dotLottiePlayer || (window.dotLottiePlayer = {
            [this._testId]: {}
        }), window.dotLottiePlayer[this._testId] = {
            direction: this._lottie.playDirection,
            currentState: this._currentState,
            loop: this.loop,
            mode: this._mode,
            speed: this._lottie.playSpeed
        });
    }
    setContainer(t) {
        t !== this._container && (this._container = t, this.setBackground(this._background), this._listenToHover());
    }
    get currentState() {
        return this._currentState;
    }
    clearCountTimer() {
        this._counterInterval && clearInterval(this._counterInterval);
    }
    setCurrentState(t) {
        this._currentState = t, this._notify(), this._updateTestData();
    }
    static isPathJSON(t) {
        var e;
        return ((e = t.split(".").pop()) == null ? void 0 : e.toLowerCase()) === "json";
    }
    get src() {
        return this._src;
    }
    updateSrc(t) {
        this._src !== t && (typeof t == "string" ? this._src = t : this._src = Rt(t), this._activeAnimationId = void 0, this._currentAnimationId = void 0, this.load());
    }
    get intermission() {
        return this._intermission;
    }
    get hover() {
        return this._hover;
    }
    setHover(t) {
        typeof t == "boolean" && (this._hover = t, this._userPlaybackOptions.hover = t, this._notify());
    }
    setIntermission(t) {
        this._intermission = t, this._userPlaybackOptions.intermission = t, this._notify();
    }
    get mode() {
        return this._mode;
    }
    get animations() {
        return this._dotLottieLoader.animationsMap;
    }
    get themes() {
        return this._dotLottieLoader.themeMap;
    }
    setMode(t) {
        typeof t == "string" && (this._mode = t, this._userPlaybackOptions.playMode = t, this._setPlayerState(()=>({
                playMode: t
            })), this._notify(), this._updateTestData());
    }
    get container() {
        if (this._container) return this._container;
    }
    goToAndPlay(t, e, i) {
        if (!this._lottie || [
            "loading"
        ].includes(this._currentState)) {
            L("goToAndPlay() Can't use whilst loading.");
            return;
        }
        this._lottie.goToAndPlay(t, e, i), this.setCurrentState("playing");
    }
    goToAndStop(t, e, i) {
        if (!this._lottie || [
            "loading"
        ].includes(this._currentState)) {
            L("goToAndStop() Can't use whilst loading.");
            return;
        }
        this._lottie.goToAndStop(t, e, i), this.setCurrentState("stopped");
    }
    seek(t) {
        if (!this._lottie || [
            "loading"
        ].includes(this._currentState)) {
            L("seek() Can't use whilst loading.");
            return;
        }
        let e = t;
        typeof e == "number" && (e = Math.round(e));
        let i = /^(\d+)(%?)$/u.exec(e.toString());
        if (!i) return;
        let n = i[2] === "%" ? this.totalFrames * Number(i[1]) / 100 : i[1];
        n !== void 0 && (this._lottie.goToAndPlay(n, !0), this.currentState === "playing" ? this.play() : this.currentState === "frozen" ? this.freeze() : this.pause());
    }
    _areNumbersInRange(t, e) {
        return t >= 0 && t <= 1 && e >= 0 && e <= 1;
    }
    _updatePosition(t, e, i) {
        let [n, r] = t != null ? t : [
            0,
            this.totalFrames - 1
        ], [o, a] = e != null ? e : [
            0,
            1
        ];
        if (!this._areNumbersInRange(o, a)) {
            tt("threshold values must be between 0 and 1");
            return;
        }
        if (this.container) {
            let { height: s, top: l } = this.container.getBoundingClientRect(), h = window.innerHeight - l, u = window.innerHeight + s, d = h / u, f = n + Math.round((d - o) / (a - o) * (r - n));
            i && i(d), this.goToAndStop(f, !0), (f >= r || d >= a) && this._handleAnimationComplete();
        }
        this._scrollTicking = !1;
    }
    _requestTick(t, e, i) {
        this._scrollTicking || (requestAnimationFrame(()=>this._updatePosition(t, e, i)), this._scrollTicking = !0);
    }
    playOnScroll(t) {
        this.stop(), this._scrollCallback && this.stopPlayOnScroll(), this._scrollCallback = ()=>this._requestTick(t == null ? void 0 : t.segments, t == null ? void 0 : t.threshold, t == null ? void 0 : t.positionCallback), window.addEventListener("scroll", this._scrollCallback);
    }
    stopPlayOnScroll() {
        this._scrollCallback && (window.removeEventListener("scroll", this._scrollCallback), this._scrollCallback = void 0);
    }
    stopPlayOnShow() {
        this._onShowIntersectionObserver && (this._onShowIntersectionObserver.disconnect(), this._onShowIntersectionObserver = void 0);
    }
    addIntersectionObserver(t) {
        if (!this.container) throw g("Can't play on show, player container element not available.");
        let e = {
            root: null,
            rootMargin: "0px",
            threshold: t != null && t.threshold ? t.threshold : [
                0,
                1
            ]
        }, i = (n)=>{
            n.forEach((r)=>{
                var o, a;
                this._visibilityPercentage = r.intersectionRatio * 100, r.isIntersecting ? (t != null && t.callbackOnIntersect && t.callbackOnIntersect(this._visibilityPercentage), (o = this._container) == null || o.dispatchEvent(new Event("visibilityChange"))) : t != null && t.callbackOnIntersect && (t.callbackOnIntersect(0), (a = this._container) == null || a.dispatchEvent(new Event("visibilityChange")));
            });
        };
        this._onShowIntersectionObserver = new IntersectionObserver(i, e), this._onShowIntersectionObserver.observe(this.container);
    }
    playOnShow(t) {
        var e;
        if (this.stop(), !this.container) throw g("Can't play on show, player container element not available.");
        this._onShowIntersectionObserver && this.stopPlayOnShow(), this.addIntersectionObserver({
            threshold: (e = t == null ? void 0 : t.threshold) != null ? e : [],
            callbackOnIntersect: (i)=>{
                i === 0 ? this.pause() : this.play();
            }
        });
    }
    _validatePlaybackOptions(t) {
        if (!t) return {};
        let e = {};
        for (let [i, n] of Object.entries(t))switch(i){
            case "autoplay":
                typeof n == "boolean" && (e.autoplay = n);
                break;
            case "direction":
                typeof n == "number" && [
                    1,
                    -1
                ].includes(n) && (e.direction = n);
                break;
            case "loop":
                (typeof n == "boolean" || typeof n == "number") && (e.loop = n);
                break;
            case "playMode":
                typeof n == "string" && [
                    "normal",
                    "bounce"
                ].includes(n) && (e.playMode = n);
                break;
            case "speed":
                typeof n == "number" && (e.speed = n);
                break;
            case "themeColor":
                typeof n == "string" && (e.themeColor = n);
                break;
            case "hover":
                typeof n == "boolean" && (e.hover = n);
                break;
            case "intermission":
                typeof n == "number" && (e.intermission = n);
                break;
            case "defaultTheme":
                typeof n == "string" && (e.defaultTheme = n);
                break;
        }
        return this._requireValidPlaybackOptions(e), e;
    }
    _requireAnimationsInTheManifest() {
        var t;
        if (!((t = this._dotLottieLoader.manifest) != null && t.animations.length)) throw g("No animations found in manifest.");
    }
    _requireAnimationsToBeLoaded() {
        if (this._dotLottieLoader.animationsMap.size === 0) throw g("No animations have been loaded.");
    }
    async play(t, e) {
        var i, n;
        if ([
            "initial",
            "loading"
        ].includes(this._currentState)) {
            L("Player unable to play whilst loading.");
            return;
        }
        if (this._requireAnimationsInTheManifest(), this._requireAnimationsToBeLoaded(), this._lottie && !t) {
            this._lottie.playDirection === -1 && this._lottie.currentFrame === 0 ? this._lottie.goToAndPlay(this._lottie.totalFrames, !0) : this._lottie.play(), this.setCurrentState("playing");
            return;
        }
        if (typeof t == "number") {
            let r = (i = this._dotLottieLoader.manifest) == null ? void 0 : i.animations[t];
            if (!r) throw g("animation not found.");
            typeof e == "function" ? await this.render({
                id: r.id,
                ...e(this._getPlaybackOptions(), this._getOptionsFromAnimation(r))
            }) : await this.render({
                id: r.id
            });
        }
        if (typeof t == "string") {
            let r = (n = this._dotLottieLoader.manifest) == null ? void 0 : n.animations.find((o)=>o.id === t);
            if (!r) throw g("animation not found.");
            typeof e == "function" ? await this.render({
                id: r.id,
                ...e(this._getPlaybackOptions(), this._getOptionsFromAnimation(r))
            }) : await this.render({
                id: r.id
            });
        }
    }
    playSegments(t, e) {
        if (!this._lottie || [
            "loading"
        ].includes(this._currentState)) {
            L("playSegments() Can't use whilst loading.");
            return;
        }
        this._lottie.playSegments(t, e), this.setCurrentState("playing");
    }
    resetSegments(t) {
        if (!this._lottie || [
            "loading"
        ].includes(this._currentState)) {
            L("resetSegments() Can't use whilst loading.");
            return;
        }
        this._lottie.resetSegments(t);
    }
    togglePlay() {
        this.currentState === "playing" ? this.pause() : this.play();
    }
    _getAnimationByIdOrIndex(t) {
        var e, i;
        if (this._requireAnimationsInTheManifest(), this._requireAnimationsToBeLoaded(), typeof t == "number") {
            let n = (e = this._dotLottieLoader.manifest) == null ? void 0 : e.animations[t];
            if (!n) throw g("animation not found.");
            return n;
        }
        if (typeof t == "string") {
            let n = (i = this._dotLottieLoader.manifest) == null ? void 0 : i.animations.find((r)=>r.id === t);
            if (!n) throw g("animation not found.");
            return n;
        }
        throw g("first param must be a number or string");
    }
    get activeAnimationId() {
        return this._getActiveAnimationId();
    }
    get currentAnimationId() {
        return this._currentAnimationId;
    }
    get activeStateId() {
        return this._activeStateId;
    }
    async _startInteractivity(t) {
        if (!this._inInteractiveMode) {
            tt("Can't start interactivity. Not in interactive mode. Call enterInteractiveMode(stateId: string) to start.");
            return;
        }
        if (this._dotLottieLoader.stateMachinesMap.size === 0 && await this._dotLottieLoader.getStateMachines(), this._dotLottieLoader.stateMachinesMap.size === 0) throw g("No interactivity states are available.");
        if (t === "undefined") throw g("stateId is not specified.");
        this._stateMachineManager || (this._stateMachineManager = await Ue(Array.from(this._dotLottieLoader.stateMachinesMap.values()), this)), this._stateMachineManager.start(t);
    }
    enterInteractiveMode(t) {
        var e;
        if (t) this._inInteractiveMode || (this._prevUserPlaybackOptions = {
            ...this._userPlaybackOptions
        }), this._inInteractiveMode && ((e = this._stateMachineManager) == null || e.stop()), this._activeStateId = t, this._inInteractiveMode = !0, this._startInteractivity(t);
        else throw g("stateId must be a non-empty string.");
    }
    exitInteractiveMode() {
        var t;
        this._inInteractiveMode && (this._inInteractiveMode = !1, this._activeStateId = "", (t = this._stateMachineManager) == null || t.stop(), this._userPlaybackOptions = {}, this._userPlaybackOptions = {
            ...this._prevUserPlaybackOptions
        }, this._prevUserPlaybackOptions = {}, this.reset());
    }
    reset() {
        var t;
        let e = this._getActiveAnimationId(), i = (t = this._dotLottieLoader.manifest) == null ? void 0 : t.animations.find((n)=>n.id === e);
        if (this._inInteractiveMode && this.exitInteractiveMode(), !i) throw g("animation not found.");
        this.play(e);
    }
    previous(t) {
        if (!this._dotLottieLoader.manifest || !this._dotLottieLoader.manifest.animations.length) throw g("manifest not found.");
        if (this._inInteractiveMode) {
            L("previous() is not supported in interactive mode.");
            return;
        }
        let e = this._dotLottieLoader.manifest.animations.findIndex((n)=>n.id === this._currentAnimationId);
        if (e === -1) throw g("animation not found.");
        let i = this._dotLottieLoader.manifest.animations[(e - 1 + this._dotLottieLoader.manifest.animations.length) % this._dotLottieLoader.manifest.animations.length];
        if (!i || !i.id) throw g("animation not found.");
        typeof t == "function" ? this.render({
            id: i.id,
            ...t(this._getPlaybackOptions(), this._getOptionsFromAnimation(i))
        }) : this.render({
            id: i.id
        });
    }
    next(t) {
        if (!this._dotLottieLoader.manifest || !this._dotLottieLoader.manifest.animations.length) throw g("manifest not found.");
        if (this._inInteractiveMode) {
            L("next() is not supported in interactive mode.");
            return;
        }
        let e = this._dotLottieLoader.manifest.animations.findIndex((n)=>n.id === this._currentAnimationId);
        if (e === -1) throw g("animation not found.");
        let i = this._dotLottieLoader.manifest.animations[(e + 1) % this._dotLottieLoader.manifest.animations.length];
        if (!i || !i.id) throw g("animation not found.");
        typeof t == "function" ? this.render({
            id: i.id,
            ...t(this._getPlaybackOptions(), this._getOptionsFromAnimation(i))
        }) : this.render({
            id: i.id
        });
    }
    getManifest() {
        return this._dotLottieLoader.manifest;
    }
    resize() {
        if (!this._lottie || [
            "loading"
        ].includes(this._currentState)) {
            L("resize() Can't use whilst loading.");
            return;
        }
        this._lottie.resize();
    }
    stop() {
        if (!this._lottie || [
            "loading"
        ].includes(this._currentState)) {
            L("stop() Can't use whilst loading.");
            return;
        }
        this.clearCountTimer(), this._counter = 0, this._setPlayerState(()=>({
                direction: this._getOption("direction")
            })), this._lottie.stop(), this.setCurrentState("stopped");
    }
    pause() {
        if (!this._lottie || [
            "loading"
        ].includes(this._currentState)) {
            L("pause() Can't use whilst loading.");
            return;
        }
        this.clearCountTimer(), this._lottie.pause(), this.setCurrentState("paused");
    }
    freeze() {
        if (!this._lottie || [
            "loading"
        ].includes(this._currentState)) {
            L("freeze() Can't use whilst loading.");
            return;
        }
        this.currentState !== "frozen" && (this._stateBeforeFreeze = this.currentState), this._lottie.pause(), this.setCurrentState("frozen");
    }
    unfreeze() {
        if (!this._lottie || [
            "loading"
        ].includes(this._currentState)) {
            L("unfreeze() Can't use whilst loading.");
            return;
        }
        this._stateBeforeFreeze === "playing" ? this.play() : this.pause();
    }
    destroy() {
        var t, e;
        (t = this._container) != null && t.__lottie && (this._container.__lottie.destroy(), this._container.__lottie = null), this._audios.length && (this._audios.forEach((i)=>{
            i.unload();
        }), this._audios = []), this.clearCountTimer(), typeof document < "u" && document.removeEventListener("visibilitychange", ()=>this._onVisibilityChange()), this._counter = 0, (e = this._lottie) == null || e.destroy(), this._lottie = void 0;
    }
    getAnimationInstance() {
        return this._lottie;
    }
    static getLottieWebVersion() {
        return `${Yi.dependencies["lottie-web"]}`;
    }
    addEventListener(t, e) {
        var i, n, r;
        this._listeners.has(t) || this._listeners.set(t, new Set), (i = this._listeners.get(t)) == null || i.add(e);
        try {
            t === "complete" ? (n = this._container) == null || n.addEventListener(t, e) : (r = this._lottie) == null || r.addEventListener(t, e);
        } catch (o) {
            tt(`addEventListener ${o}`);
        }
    }
    getState() {
        var t, e, i, n, r, o, a;
        return {
            autoplay: (e = (t = this._lottie) == null ? void 0 : t.autoplay) != null ? e : !1,
            currentState: this._currentState,
            frame: this._frame,
            visibilityPercentage: this._visibilityPercentage,
            seeker: this._seeker,
            direction: (n = (i = this._lottie) == null ? void 0 : i.playDirection) != null ? n : 1,
            hover: this._hover,
            loop: this._loop || !1,
            playMode: this._mode,
            speed: (o = (r = this._lottie) == null ? void 0 : r.playSpeed) != null ? o : 1,
            background: this._background,
            intermission: this._intermission,
            defaultTheme: this._defaultTheme,
            currentAnimationId: this._currentAnimationId,
            activeStateId: (a = this._activeStateId) != null ? a : ""
        };
    }
    _notify() {
        this.state.setState(this.getState());
    }
    get totalFrames() {
        var t;
        return ((t = this._lottie) == null ? void 0 : t.totalFrames) || 0;
    }
    get direction() {
        return this._lottie ? this._lottie.playDirection : 1;
    }
    setDirection(t) {
        this._requireValidDirection(t), this._setPlayerState(()=>({
                direction: t
            })), this._userPlaybackOptions.direction = t;
    }
    get speed() {
        var t;
        return ((t = this._lottie) == null ? void 0 : t.playSpeed) || 1;
    }
    setSpeed(t) {
        this._requireValidSpeed(t), this._setPlayerState(()=>({
                speed: t
            })), this._userPlaybackOptions.speed = t;
    }
    get autoplay() {
        var t, e;
        return (e = (t = this._lottie) == null ? void 0 : t.autoplay) != null ? e : !1;
    }
    setAutoplay(t) {
        if (this._requireValidAutoplay(t), !this._lottie || [
            "loading"
        ].includes(this._currentState)) {
            L("setAutoplay() Can't use whilst loading.");
            return;
        }
        this._setPlayerState(()=>({
                autoplay: t
            })), this._userPlaybackOptions.autoplay = t;
    }
    toggleAutoplay() {
        if (!this._lottie || [
            "loading"
        ].includes(this._currentState)) {
            L("toggleAutoplay() Can't use whilst loading.");
            return;
        }
        this.setAutoplay(!this._lottie.autoplay);
    }
    get defaultTheme() {
        return this._defaultTheme;
    }
    setDefaultTheme(t) {
        this._setPlayerState(()=>({
                defaultTheme: t
            })), this._userPlaybackOptions.defaultTheme = t, this._animation && this.render();
    }
    get loop() {
        return this._loop;
    }
    setLoop(t) {
        this._requireValidLoop(t), this._setPlayerState(()=>({
                loop: t
            })), this._userPlaybackOptions.loop = t;
    }
    toggleLoop() {
        if (!this._lottie || [
            "loading"
        ].includes(this._currentState)) {
            L("toggleLoop() Can't use whilst loading.");
            return;
        }
        this.setLoop(!this._loop);
    }
    get background() {
        return this._background;
    }
    setBackground(t) {
        this._requireValidBackground(t), this._background = t, this._container && (this._container.style.backgroundColor = t);
    }
    get _frame() {
        return this._lottie ? this.currentState === "completed" ? this.direction === -1 ? 0 : this._lottie.totalFrames : this._lottie.currentFrame : 0;
    }
    get _seeker() {
        return this._lottie ? this._frame / this._lottie.totalFrames * 100 : 0;
    }
    async revertToManifestValues(t) {
        var e;
        let i;
        !Array.isArray(t) || t.length === 0 ? i = [
            "autoplay",
            "defaultTheme",
            "direction",
            "hover",
            "intermission",
            "loop",
            "playMode",
            "speed",
            "activeAnimationId"
        ] : i = t;
        let n = !1;
        if (i.includes("activeAnimationId")) {
            let r = (e = this._dotLottieLoader.manifest) == null ? void 0 : e.activeAnimationId, o = this._getAnimationByIdOrIndex(r || 0);
            this._activeAnimationId = r, await this._setCurrentAnimation(o.id), n = !0;
        }
        i.forEach((r)=>{
            switch(r){
                case "autoplay":
                    delete this._userPlaybackOptions.autoplay, this.setAutoplay(this._getOption("autoplay"));
                    break;
                case "defaultTheme":
                    delete this._userPlaybackOptions.defaultTheme, this.setDefaultTheme(this._getOption("defaultTheme"));
                    break;
                case "direction":
                    delete this._userPlaybackOptions.direction, this.setDirection(this._getOption("direction"));
                    break;
                case "hover":
                    delete this._userPlaybackOptions.hover, this.setHover(this._getOption("hover"));
                    break;
                case "intermission":
                    delete this._userPlaybackOptions.intermission, this.setIntermission(this._getOption("intermission"));
                    break;
                case "loop":
                    delete this._userPlaybackOptions.loop, this.setLoop(this._getOption("loop"));
                    break;
                case "playMode":
                    delete this._userPlaybackOptions.playMode, this.setMode(this._getOption("playMode")), this.setDirection(this._getOption("direction"));
                    break;
                case "speed":
                    delete this._userPlaybackOptions.speed, this.setSpeed(this._getOption("speed"));
                    break;
            }
        }), n && this.render();
    }
    removeEventListener(t, e) {
        var i, n, r;
        try {
            t === "complete" ? (i = this._container) == null || i.removeEventListener(t, e) : (n = this._lottie) == null || n.removeEventListener(t, e), (r = this._listeners.get(t)) == null || r.delete(e);
        } catch (o) {
            tt("removeEventListener", o);
        }
    }
    _handleAnimationComplete() {
        var t;
        typeof this._loop == "number" && this.stop();
        let e = this.direction === -1 ? 0 : this.totalFrames;
        this.goToAndStop(e, !0), this._counter = 0, this.clearCountTimer(), this.setCurrentState("completed"), (t = this._container) == null || t.dispatchEvent(new Event("complete"));
    }
    addEventListeners() {
        var t;
        if (!this._lottie || [
            "loading"
        ].includes(this._currentState)) {
            L("addEventListeners() Can't use whilst loading.");
            return;
        }
        this._lottie.addEventListener("enterFrame", ()=>{
            var e;
            if (!this._lottie) {
                L("enterFrame event : Lottie is undefined.");
                return;
            }
            Math.floor(this._lottie.currentFrame) === 0 && this.direction === -1 && ((e = this._container) == null || e.dispatchEvent(new Event("complete")), this.loop || this.setCurrentState("completed")), this._notify();
        }), this._lottie.addEventListener("loopComplete", ()=>{
            var e;
            if (!this._lottie) {
                L("loopComplete event : Lottie is undefined.");
                return;
            }
            (e = this._container) == null || e.dispatchEvent(new Event("loopComplete")), this.intermission > 0 && this.pause();
            let i = this._lottie.playDirection;
            if (typeof this._loop == "number" && this._loop > 0 && (this._counter += this._mode === "bounce" ? .5 : 1, this._counter >= this._loop)) {
                this._handleAnimationComplete();
                return;
            }
            this._mode === "bounce" && typeof i == "number" && (i = Number(i) * -1);
            let n = i === -1 ? this._lottie.totalFrames - 1 : 0;
            this.intermission ? (this.goToAndPlay(n, !0), this.pause(), this._counterInterval = window.setTimeout(()=>{
                this._lottie && (this._setPlayerState(()=>({
                        direction: i
                    })), this.goToAndPlay(n, !0));
            }, this._intermission)) : (this._setPlayerState(()=>({
                    direction: i
                })), this.goToAndPlay(i === -1 ? this.totalFrames - 1 : 0, !0));
        }), this._lottie.addEventListener("complete", ()=>{
            if (this._lottie && this._loop === !1 && this._mode === "bounce") {
                if (this._counter += .5, this._counter >= 1) {
                    this._handleAnimationComplete();
                    return;
                }
                this._counterInterval = window.setTimeout(()=>{
                    if (!this._lottie) return;
                    let e = this._lottie.playDirection;
                    this._mode === "bounce" && typeof e == "number" && (e = Number(e) * -1);
                    let i = e === -1 ? this.totalFrames - 1 : 0;
                    this._setPlayerState(()=>({
                            direction: e
                        })), this.goToAndPlay(i, !0);
                }, this._intermission);
            } else this._handleAnimationComplete();
        });
        for (let [e, i] of this._listeners)if (e === "complete") for (let n of i)(t = this._container) == null || t.addEventListener(e, n);
        else for (let n of i)this._lottie.addEventListener(e, n);
    }
    async _setCurrentAnimation(t) {
        this._currentState = "loading";
        let e = await this._dotLottieLoader.getAnimation(t);
        this._currentAnimationId = t, this._animation = e, this._currentState = "ready";
    }
    async _getAudioFactory() {
        if (this._animation && Pe(this._animation)) {
            let { DotLottieAudio: t } = await (parcelRequire("lSVtM"));
            return (e)=>{
                let i = new t({
                    src: [
                        e
                    ]
                });
                return this._audios.push(i), i;
            };
        }
        return null;
    }
    async render(t) {
        var e, i, n, r, o, a, s, l, h, u, d, f, p, m, c, v, _, S;
        if (t != null && t.id) await this._setCurrentAnimation(t.id);
        else if (!this._animation) throw g("no animation selected");
        let y = (e = V.loop) != null ? e : !1, E = (i = V.autoplay) != null ? i : !1, M = (n = V.playMode) != null ? n : "normal", D = (r = V.intermission) != null ? r : 0, I = (o = V.hover) != null ? o : !1, F = (a = V.direction) != null ? a : 1, j = (s = V.speed) != null ? s : 1, q = (l = V.defaultTheme) != null ? l : "";
        y = (h = t == null ? void 0 : t.loop) != null ? h : this._getOption("loop"), E = (u = t == null ? void 0 : t.autoplay) != null ? u : this._getOption("autoplay"), M = (d = t == null ? void 0 : t.playMode) != null ? d : this._getOption("playMode"), D = (f = t == null ? void 0 : t.intermission) != null ? f : this._getOption("intermission"), I = (p = t == null ? void 0 : t.hover) != null ? p : this._getOption("hover"), F = (m = t == null ? void 0 : t.direction) != null ? m : this._getOption("direction"), j = (c = t == null ? void 0 : t.speed) != null ? c : this._getOption("speed"), q = (v = t == null ? void 0 : t.defaultTheme) != null ? v : this._getOption("defaultTheme");
        let A = {
            ...this._animationConfig,
            autoplay: I ? !1 : E,
            loop: typeof y == "number" ? !0 : y,
            renderer: this._worker ? "svg" : (_ = this._animationConfig.renderer) != null ? _ : "svg"
        }, [k, B, W] = await Promise.all([
            this._dotLottieLoader.getTheme(q),
            this._getLottiePlayerInstance(),
            this._getAudioFactory()
        ]);
        if (k && this._animation ? this._animation = await Te(this._animation, k) : this._animation = await this._dotLottieLoader.getAnimation((S = this._currentAnimationId) != null ? S : ""), this._activeStateId && !this._inInteractiveMode) {
            this.enterInteractiveMode(this._activeStateId);
            return;
        }
        this.destroy(), this._setPlayerState(()=>({
                defaultTheme: q,
                playMode: M,
                intermission: D,
                hover: I,
                loop: y
            })), W ? this._lottie = B.loadAnimation({
            ...A,
            container: this._container,
            animationData: this._animation,
            audioFactory: W
        }) : this._lottie = B.loadAnimation({
            ...A,
            container: this._container,
            animationData: this._animation
        }), typeof this._lottie.resetSegments > "u" && (this._lottie.resetSegments = ()=>{
            var N;
            (N = this._lottie) == null || N.playSegments([
                0,
                this._lottie.totalFrames
            ], !0);
        }), this.addEventListeners(), this._container && (this._container.__lottie = this._lottie), this._setPlayerState(()=>({
                direction: F,
                speed: j
            })), E && !I && this.play(), this._updateTestData();
    }
    async _getLottiePlayerInstance() {
        var t;
        let e = (t = this._animationConfig.renderer) != null ? t : "svg", i;
        if (this._worker) return e !== "svg" && L("Worker is only supported with svg renderer. Change or remove renderer prop to get rid of this warning."), i = await (parcelRequire("9p4UM")), i.default;
        switch(e){
            case "svg":
                this._light ? i = await (parcelRequire("cjXnx")) : i = await (parcelRequire("hwDK5"));
                break;
            case "canvas":
                this._light ? i = await (parcelRequire("d1U0i")) : i = await (parcelRequire("jRxcc"));
                break;
            case "html":
                this._light ? i = await (parcelRequire("hTkBp")) : i = await (parcelRequire("5UW7s"));
                break;
            default:
                throw new Error(`Invalid renderer: ${e}`);
        }
        return i.default;
    }
    _getActiveAnimationId() {
        var t, e, i, n;
        let r = this._dotLottieLoader.manifest;
        return (n = (i = (t = this._activeAnimationId) != null ? t : r == null ? void 0 : r.activeAnimationId) != null ? i : (e = r == null ? void 0 : r.animations[0]) == null ? void 0 : e.id) != null ? n : void 0;
    }
    async load(t) {
        if (this._currentState === "loading") {
            L("Loading in progress..");
            return;
        }
        try {
            if (this.setCurrentState("loading"), typeof this._src == "string") {
                if (Ce(this._src)) {
                    let i = JSON.parse(this._src);
                    this._dotLottieLoader.loadFromLottieJSON(i);
                } else {
                    let i = new URL(this._src, window.location.href);
                    await this._dotLottieLoader.loadFromUrl(i.toString());
                }
            } else if (typeof this._src == "object" && ot(this._src)) this._dotLottieLoader.loadFromLottieJSON(this._src);
            else throw g("Invalid src provided");
            if (!this._dotLottieLoader.manifest) throw g("No manifest found");
            let e = this._getActiveAnimationId();
            if (!e) throw g("No active animation found");
            await this._setCurrentAnimation(e), await this.render(t);
        } catch (e) {
            this.setCurrentState("error"), e instanceof Error && tt(`Error loading animation: ${e.message}`);
        }
    }
    setErrorState(t) {
        this.setCurrentState("error"), tt(t);
    }
    _requireValidDirection(t) {
        if (t !== -1 && t !== 1) throw g("Direction can only be -1 (backwards) or 1 (forwards)");
    }
    _requireValidIntermission(t) {
        if (t < 0 || !Number.isInteger(t)) throw g("intermission must be a positive number");
    }
    _requireValidLoop(t) {
        if (typeof t == "number" && (!Number.isInteger(t) || t < 0)) throw g("loop must be a positive number or boolean");
    }
    _requireValidSpeed(t) {
        if (typeof t != "number") throw g("speed must be a number");
    }
    _requireValidBackground(t) {
        if (typeof t != "string") throw g("background must be a string");
    }
    _requireValidAutoplay(t) {
        if (typeof t != "boolean") throw g("autoplay must be a boolean");
    }
    _requireValidPlaybackOptions(t) {
        t.direction && this._requireValidDirection(t.direction), t.intermission && this._requireValidIntermission(t.intermission), t.loop && this._requireValidLoop(t.loop), t.speed && this._requireValidSpeed(t.speed);
    }
};
 //# sourceMappingURL=out.js.map

});
parcelRegister("ihoyg", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $d4ecdbf520e63dca$export$a143d493d941bafc; }, function (v) { return $d4ecdbf520e63dca$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $d4ecdbf520e63dca$export$f99ded8fe4b79145; }, function (v) { return $d4ecdbf520e63dca$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $d4ecdbf520e63dca$export$a143d493d941bafc;
var $d4ecdbf520e63dca$export$e4cf37d7f6fb9e0a;
var $d4ecdbf520e63dca$export$f99ded8fe4b79145;
var $d4ecdbf520e63dca$export$599f31c3813fae4d;
"use strict";

var $hqZtu = parcelRequire("hqZtu");

var $5WQj6 = parcelRequire("5WQj6");
var $d4ecdbf520e63dca$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$d4ecdbf520e63dca$export$a143d493d941bafc = $d4ecdbf520e63dca$var$Buffer;
$d4ecdbf520e63dca$export$e4cf37d7f6fb9e0a = $d4ecdbf520e63dca$var$SlowBuffer;
$d4ecdbf520e63dca$export$f99ded8fe4b79145 = 50;
var $d4ecdbf520e63dca$var$K_MAX_LENGTH = 0x7fffffff;
$d4ecdbf520e63dca$export$599f31c3813fae4d = $d4ecdbf520e63dca$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $d4ecdbf520e63dca$var$Buffer.TYPED_ARRAY_SUPPORT = $d4ecdbf520e63dca$var$typedArraySupport();
if (!$d4ecdbf520e63dca$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $d4ecdbf520e63dca$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($d4ecdbf520e63dca$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($d4ecdbf520e63dca$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $d4ecdbf520e63dca$var$createBuffer(length) {
    if (length > $d4ecdbf520e63dca$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $d4ecdbf520e63dca$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $d4ecdbf520e63dca$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $d4ecdbf520e63dca$var$allocUnsafe(arg);
    }
    return $d4ecdbf520e63dca$var$from(arg, encodingOrOffset, length);
}
$d4ecdbf520e63dca$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $d4ecdbf520e63dca$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $d4ecdbf520e63dca$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $d4ecdbf520e63dca$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($d4ecdbf520e63dca$var$isInstance(value, ArrayBuffer) || value && $d4ecdbf520e63dca$var$isInstance(value.buffer, ArrayBuffer)) return $d4ecdbf520e63dca$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($d4ecdbf520e63dca$var$isInstance(value, SharedArrayBuffer) || value && $d4ecdbf520e63dca$var$isInstance(value.buffer, SharedArrayBuffer))) return $d4ecdbf520e63dca$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $d4ecdbf520e63dca$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $d4ecdbf520e63dca$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $d4ecdbf520e63dca$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $d4ecdbf520e63dca$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $d4ecdbf520e63dca$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($d4ecdbf520e63dca$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($d4ecdbf520e63dca$var$Buffer, Uint8Array);
function $d4ecdbf520e63dca$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $d4ecdbf520e63dca$var$alloc(size, fill, encoding) {
    $d4ecdbf520e63dca$var$assertSize(size);
    if (size <= 0) return $d4ecdbf520e63dca$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $d4ecdbf520e63dca$var$createBuffer(size).fill(fill, encoding) : $d4ecdbf520e63dca$var$createBuffer(size).fill(fill);
    return $d4ecdbf520e63dca$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $d4ecdbf520e63dca$var$Buffer.alloc = function(size, fill, encoding) {
    return $d4ecdbf520e63dca$var$alloc(size, fill, encoding);
};
function $d4ecdbf520e63dca$var$allocUnsafe(size) {
    $d4ecdbf520e63dca$var$assertSize(size);
    return $d4ecdbf520e63dca$var$createBuffer(size < 0 ? 0 : $d4ecdbf520e63dca$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $d4ecdbf520e63dca$var$Buffer.allocUnsafe = function(size) {
    return $d4ecdbf520e63dca$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $d4ecdbf520e63dca$var$Buffer.allocUnsafeSlow = function(size) {
    return $d4ecdbf520e63dca$var$allocUnsafe(size);
};
function $d4ecdbf520e63dca$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$d4ecdbf520e63dca$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    var length = $d4ecdbf520e63dca$var$byteLength(string, encoding) | 0;
    var buf = $d4ecdbf520e63dca$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $d4ecdbf520e63dca$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $d4ecdbf520e63dca$var$checked(array.length) | 0;
    var buf = $d4ecdbf520e63dca$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $d4ecdbf520e63dca$var$fromArrayView(arrayView) {
    if ($d4ecdbf520e63dca$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $d4ecdbf520e63dca$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $d4ecdbf520e63dca$var$fromArrayLike(arrayView);
}
function $d4ecdbf520e63dca$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $d4ecdbf520e63dca$var$Buffer.prototype);
    return buf;
}
function $d4ecdbf520e63dca$var$fromObject(obj) {
    if ($d4ecdbf520e63dca$var$Buffer.isBuffer(obj)) {
        var len = $d4ecdbf520e63dca$var$checked(obj.length) | 0;
        var buf = $d4ecdbf520e63dca$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $d4ecdbf520e63dca$var$numberIsNaN(obj.length)) return $d4ecdbf520e63dca$var$createBuffer(0);
        return $d4ecdbf520e63dca$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $d4ecdbf520e63dca$var$fromArrayLike(obj.data);
}
function $d4ecdbf520e63dca$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $d4ecdbf520e63dca$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $d4ecdbf520e63dca$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $d4ecdbf520e63dca$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $d4ecdbf520e63dca$var$Buffer.alloc(+length);
}
$d4ecdbf520e63dca$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $d4ecdbf520e63dca$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$d4ecdbf520e63dca$var$Buffer.compare = function compare(a, b) {
    if ($d4ecdbf520e63dca$var$isInstance(a, Uint8Array)) a = $d4ecdbf520e63dca$var$Buffer.from(a, a.offset, a.byteLength);
    if ($d4ecdbf520e63dca$var$isInstance(b, Uint8Array)) b = $d4ecdbf520e63dca$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(a) || !$d4ecdbf520e63dca$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$d4ecdbf520e63dca$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$d4ecdbf520e63dca$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $d4ecdbf520e63dca$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $d4ecdbf520e63dca$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($d4ecdbf520e63dca$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $d4ecdbf520e63dca$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $d4ecdbf520e63dca$var$byteLength(string, encoding) {
    if ($d4ecdbf520e63dca$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $d4ecdbf520e63dca$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $d4ecdbf520e63dca$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $d4ecdbf520e63dca$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $d4ecdbf520e63dca$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$d4ecdbf520e63dca$var$Buffer.byteLength = $d4ecdbf520e63dca$var$byteLength;
function $d4ecdbf520e63dca$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $d4ecdbf520e63dca$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $d4ecdbf520e63dca$var$utf8Slice(this, start, end);
        case "ascii":
            return $d4ecdbf520e63dca$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $d4ecdbf520e63dca$var$latin1Slice(this, start, end);
        case "base64":
            return $d4ecdbf520e63dca$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $d4ecdbf520e63dca$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$d4ecdbf520e63dca$var$Buffer.prototype._isBuffer = true;
function $d4ecdbf520e63dca$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$d4ecdbf520e63dca$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)$d4ecdbf520e63dca$var$swap(this, i, i + 1);
    return this;
};
$d4ecdbf520e63dca$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        $d4ecdbf520e63dca$var$swap(this, i, i + 3);
        $d4ecdbf520e63dca$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$d4ecdbf520e63dca$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        $d4ecdbf520e63dca$var$swap(this, i, i + 7);
        $d4ecdbf520e63dca$var$swap(this, i + 1, i + 6);
        $d4ecdbf520e63dca$var$swap(this, i + 2, i + 5);
        $d4ecdbf520e63dca$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$d4ecdbf520e63dca$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $d4ecdbf520e63dca$var$utf8Slice(this, 0, length);
    return $d4ecdbf520e63dca$var$slowToString.apply(this, arguments);
};
$d4ecdbf520e63dca$var$Buffer.prototype.toLocaleString = $d4ecdbf520e63dca$var$Buffer.prototype.toString;
$d4ecdbf520e63dca$var$Buffer.prototype.equals = function equals(b) {
    if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $d4ecdbf520e63dca$var$Buffer.compare(this, b) === 0;
};
$d4ecdbf520e63dca$var$Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = $d4ecdbf520e63dca$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($d4ecdbf520e63dca$var$customInspectSymbol) $d4ecdbf520e63dca$var$Buffer.prototype[$d4ecdbf520e63dca$var$customInspectSymbol] = $d4ecdbf520e63dca$var$Buffer.prototype.inspect;
$d4ecdbf520e63dca$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($d4ecdbf520e63dca$var$isInstance(target, Uint8Array)) target = $d4ecdbf520e63dca$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $d4ecdbf520e63dca$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($d4ecdbf520e63dca$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $d4ecdbf520e63dca$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($d4ecdbf520e63dca$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $d4ecdbf520e63dca$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $d4ecdbf520e63dca$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $d4ecdbf520e63dca$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$d4ecdbf520e63dca$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$d4ecdbf520e63dca$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $d4ecdbf520e63dca$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$d4ecdbf520e63dca$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $d4ecdbf520e63dca$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $d4ecdbf520e63dca$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($d4ecdbf520e63dca$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $d4ecdbf520e63dca$var$utf8Write(buf, string, offset, length) {
    return $d4ecdbf520e63dca$var$blitBuffer($d4ecdbf520e63dca$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $d4ecdbf520e63dca$var$asciiWrite(buf, string, offset, length) {
    return $d4ecdbf520e63dca$var$blitBuffer($d4ecdbf520e63dca$var$asciiToBytes(string), buf, offset, length);
}
function $d4ecdbf520e63dca$var$base64Write(buf, string, offset, length) {
    return $d4ecdbf520e63dca$var$blitBuffer($d4ecdbf520e63dca$var$base64ToBytes(string), buf, offset, length);
}
function $d4ecdbf520e63dca$var$ucs2Write(buf, string, offset, length) {
    return $d4ecdbf520e63dca$var$blitBuffer($d4ecdbf520e63dca$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$d4ecdbf520e63dca$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $d4ecdbf520e63dca$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $d4ecdbf520e63dca$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $d4ecdbf520e63dca$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $d4ecdbf520e63dca$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $d4ecdbf520e63dca$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$d4ecdbf520e63dca$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $d4ecdbf520e63dca$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $hqZtu.fromByteArray(buf);
    else return $hqZtu.fromByteArray(buf.slice(start, end));
}
function $d4ecdbf520e63dca$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $d4ecdbf520e63dca$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $d4ecdbf520e63dca$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $d4ecdbf520e63dca$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $d4ecdbf520e63dca$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $d4ecdbf520e63dca$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $d4ecdbf520e63dca$var$asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $d4ecdbf520e63dca$var$latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $d4ecdbf520e63dca$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += $d4ecdbf520e63dca$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $d4ecdbf520e63dca$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$d4ecdbf520e63dca$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $d4ecdbf520e63dca$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $d4ecdbf520e63dca$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$d4ecdbf520e63dca$var$Buffer.prototype.readUintLE = $d4ecdbf520e63dca$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUintBE = $d4ecdbf520e63dca$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUint8 = $d4ecdbf520e63dca$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUint16LE = $d4ecdbf520e63dca$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUint16BE = $d4ecdbf520e63dca$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUint32LE = $d4ecdbf520e63dca$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUint32BE = $d4ecdbf520e63dca$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$d4ecdbf520e63dca$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$d4ecdbf520e63dca$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return $5WQj6.read(this, offset, true, 23, 4);
};
$d4ecdbf520e63dca$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return $5WQj6.read(this, offset, false, 23, 4);
};
$d4ecdbf520e63dca$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 8, this.length);
    return $5WQj6.read(this, offset, true, 52, 8);
};
$d4ecdbf520e63dca$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 8, this.length);
    return $5WQj6.read(this, offset, false, 52, 8);
};
function $d4ecdbf520e63dca$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$d4ecdbf520e63dca$var$Buffer.prototype.writeUintLE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $d4ecdbf520e63dca$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUintBE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $d4ecdbf520e63dca$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUint8 = $d4ecdbf520e63dca$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUint16LE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUint16BE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUint32LE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUint32BE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $d4ecdbf520e63dca$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $d4ecdbf520e63dca$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $d4ecdbf520e63dca$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $d4ecdbf520e63dca$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $5WQj6.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$d4ecdbf520e63dca$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $d4ecdbf520e63dca$var$writeFloat(this, value, offset, true, noAssert);
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $d4ecdbf520e63dca$var$writeFloat(this, value, offset, false, noAssert);
};
function $d4ecdbf520e63dca$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $5WQj6.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$d4ecdbf520e63dca$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $d4ecdbf520e63dca$var$writeDouble(this, value, offset, true, noAssert);
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $d4ecdbf520e63dca$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$d4ecdbf520e63dca$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$d4ecdbf520e63dca$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$d4ecdbf520e63dca$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $d4ecdbf520e63dca$var$Buffer.isBuffer(val) ? val : $d4ecdbf520e63dca$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $d4ecdbf520e63dca$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $d4ecdbf520e63dca$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($d4ecdbf520e63dca$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $d4ecdbf520e63dca$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $d4ecdbf520e63dca$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $d4ecdbf520e63dca$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $d4ecdbf520e63dca$var$base64ToBytes(str) {
    return $hqZtu.toByteArray($d4ecdbf520e63dca$var$base64clean(str));
}
function $d4ecdbf520e63dca$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $d4ecdbf520e63dca$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $d4ecdbf520e63dca$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $d4ecdbf520e63dca$var$hexSliceLookupTable = function() {
    var alphabet = "0123456789abcdef";
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

});
parcelRegister("hqZtu", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $034686670a8a195b$export$d622b2ad8d90c771; }, function (v) { return $034686670a8a195b$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $034686670a8a195b$export$6100ba28696e12de; }, function (v) { return $034686670a8a195b$export$6100ba28696e12de = v; });
var $034686670a8a195b$export$a48f0734ac7c2329;
var $034686670a8a195b$export$d622b2ad8d90c771;
var $034686670a8a195b$export$6100ba28696e12de;
"use strict";
$034686670a8a195b$export$a48f0734ac7c2329 = $034686670a8a195b$var$byteLength;
$034686670a8a195b$export$d622b2ad8d90c771 = $034686670a8a195b$var$toByteArray;
$034686670a8a195b$export$6100ba28696e12de = $034686670a8a195b$var$fromByteArray;
var $034686670a8a195b$var$lookup = [];
var $034686670a8a195b$var$revLookup = [];
var $034686670a8a195b$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $034686670a8a195b$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $034686670a8a195b$var$i = 0, $034686670a8a195b$var$len = $034686670a8a195b$var$code.length; $034686670a8a195b$var$i < $034686670a8a195b$var$len; ++$034686670a8a195b$var$i){
    $034686670a8a195b$var$lookup[$034686670a8a195b$var$i] = $034686670a8a195b$var$code[$034686670a8a195b$var$i];
    $034686670a8a195b$var$revLookup[$034686670a8a195b$var$code.charCodeAt($034686670a8a195b$var$i)] = $034686670a8a195b$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$034686670a8a195b$var$revLookup["-".charCodeAt(0)] = 62;
$034686670a8a195b$var$revLookup["_".charCodeAt(0)] = 63;
function $034686670a8a195b$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $034686670a8a195b$var$byteLength(b64) {
    var lens = $034686670a8a195b$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $034686670a8a195b$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $034686670a8a195b$var$toByteArray(b64) {
    var tmp;
    var lens = $034686670a8a195b$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $034686670a8a195b$var$Arr($034686670a8a195b$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $034686670a8a195b$var$revLookup[b64.charCodeAt(i)] << 18 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $034686670a8a195b$var$revLookup[b64.charCodeAt(i)] << 2 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $034686670a8a195b$var$revLookup[b64.charCodeAt(i)] << 10 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $034686670a8a195b$var$tripletToBase64(num) {
    return $034686670a8a195b$var$lookup[num >> 18 & 0x3F] + $034686670a8a195b$var$lookup[num >> 12 & 0x3F] + $034686670a8a195b$var$lookup[num >> 6 & 0x3F] + $034686670a8a195b$var$lookup[num & 0x3F];
}
function $034686670a8a195b$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($034686670a8a195b$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $034686670a8a195b$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($034686670a8a195b$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($034686670a8a195b$var$lookup[tmp >> 2] + $034686670a8a195b$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($034686670a8a195b$var$lookup[tmp >> 10] + $034686670a8a195b$var$lookup[tmp >> 4 & 0x3F] + $034686670a8a195b$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("5WQj6", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $454af19f7384844b$export$aafa59e2e03f2942; }, function (v) { return $454af19f7384844b$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $454af19f7384844b$export$68d8715fc104d294; }, function (v) { return $454af19f7384844b$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $454af19f7384844b$export$aafa59e2e03f2942;
var $454af19f7384844b$export$68d8715fc104d294;
$454af19f7384844b$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$454af19f7384844b$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("XwHZu", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = $hffE7("bHzJf").then(()=>parcelRequire("aK3UN"));

});
parcelRegister("hffE7", function(module, exports) {
"use strict";

function $c8dff9588896671a$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("kyEFX")).resolve(id));
}
module.exports = $c8dff9588896671a$var$load;

});


parcelRegister("iVO9V", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = $hffE7("bRj6G").then(()=>parcelRequire("Mi1RM"));

});

parcelRegister("9j6Ub", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = $hffE7("4HZCL").then(()=>parcelRequire("jrckM"));

});

parcelRegister("lSVtM", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = $hffE7("8Dbd0").then(()=>parcelRequire("22wzD"));

});

parcelRegister("9p4UM", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = $hffE7("lO1lP").then(()=>parcelRequire("i2dBO"));

});

parcelRegister("cjXnx", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = $hffE7("5f6ly").then(()=>parcelRequire("1sxlV"));

});

parcelRegister("hwDK5", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = $hffE7("4xuYT").then(()=>parcelRequire("8FR5e"));

});

parcelRegister("d1U0i", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = $hffE7("4q1l2").then(()=>parcelRequire("fskGM"));

});

parcelRegister("jRxcc", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = $hffE7("3Yd1q").then(()=>parcelRequire("cQduJ"));

});

parcelRegister("hTkBp", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = $hffE7("a1yqe").then(()=>parcelRequire("8veyn"));

});

parcelRegister("5UW7s", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = $hffE7("1hkgq").then(()=>parcelRequire("cju0U"));

});


parcelRegister("g90QB", function(module, exports) {

$parcel$export(module.exports, "a", function () { return $a0c0733774e888fd$export$407448d2b89b1813; });
$parcel$export(module.exports, "b", function () { return $a0c0733774e888fd$export$8b22cf2602fb60ce; });
var $a0c0733774e888fd$var$l = Object.create, $a0c0733774e888fd$var$a = Object.defineProperty, $a0c0733774e888fd$var$n = Object.getOwnPropertyDescriptor, $a0c0733774e888fd$var$f = Object.getOwnPropertyNames, $a0c0733774e888fd$var$O = Object.getPrototypeOf, $a0c0733774e888fd$var$c = Object.prototype.hasOwnProperty, $a0c0733774e888fd$export$407448d2b89b1813 = (r, e)=>()=>(e || r((e = {
            exports: {}
        }).exports, e), e.exports), $a0c0733774e888fd$var$s = (r, e, t, p)=>{
    if (e && typeof e == "object" || typeof e == "function") for (let o of $a0c0733774e888fd$var$f(e))!$a0c0733774e888fd$var$c.call(r, o) && o !== t && $a0c0733774e888fd$var$a(r, o, {
        get: ()=>e[o],
        enumerable: !(p = $a0c0733774e888fd$var$n(e, o)) || p.enumerable
    });
    return r;
}, $a0c0733774e888fd$export$8b22cf2602fb60ce = (r, e, t)=>(t = r != null ? $a0c0733774e888fd$var$l($a0c0733774e888fd$var$O(r)) : {}, $a0c0733774e888fd$var$s(e || !r || !r.__esModule ? $a0c0733774e888fd$var$a(t, "default", {
        value: r,
        enumerable: !0
    }) : t, r));
 //# sourceMappingURL=out.js.map

});

parcelRegister("bL0Ij", function(module, exports) {

$parcel$export(module.exports, "a", function () { return $453c22262927fdde$export$407448d2b89b1813; });
var $453c22262927fdde$var$h = Object.defineProperty;
var $453c22262927fdde$var$i = Object.getOwnPropertyDescriptor;
var $453c22262927fdde$export$407448d2b89b1813 = (g, b, d, c)=>{
    for(var a = c > 1 ? void 0 : c ? $453c22262927fdde$var$i(b, d) : b, e = g.length - 1, f; e >= 0; e--)(f = g[e]) && (a = (c ? f(b, d, a) : f(a)) || a);
    return c && a && $453c22262927fdde$var$h(b, d, a), a;
};
 //# sourceMappingURL=out.js.map

});

var $2883a5bab490bd30$var$N = window, $2883a5bab490bd30$var$R = $2883a5bab490bd30$var$N.ShadowRoot && ($2883a5bab490bd30$var$N.ShadyCSS === void 0 || $2883a5bab490bd30$var$N.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, $2883a5bab490bd30$var$M = Symbol(), $2883a5bab490bd30$var$tt = new WeakMap, $2883a5bab490bd30$var$S = class {
    constructor(t, e, o){
        if (this._$cssResult$ = !0, o !== $2883a5bab490bd30$var$M) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
        this.cssText = t, this.t = e;
    }
    get styleSheet() {
        let t = this.o, e = this.t;
        if ($2883a5bab490bd30$var$R && t === void 0) {
            let o = e !== void 0 && e.length === 1;
            o && (t = $2883a5bab490bd30$var$tt.get(e)), t === void 0 && ((this.o = t = new CSSStyleSheet).replaceSync(this.cssText), o && $2883a5bab490bd30$var$tt.set(e, t));
        }
        return t;
    }
    toString() {
        return this.cssText;
    }
}, $2883a5bab490bd30$var$et = (r)=>new $2883a5bab490bd30$var$S(typeof r == "string" ? r : r + "", void 0, $2883a5bab490bd30$var$M), $2883a5bab490bd30$var$j = (r, ...t)=>{
    let e = r.length === 1 ? r[0] : t.reduce((o, i, n)=>o + ((s)=>{
            if (s._$cssResult$ === !0) return s.cssText;
            if (typeof s == "number") return s;
            throw Error("Value passed to 'css' function must be a 'css' function result: " + s + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
        })(i) + r[n + 1], r[0]);
    return new $2883a5bab490bd30$var$S(e, r, $2883a5bab490bd30$var$M);
}, $2883a5bab490bd30$var$L = (r, t)=>{
    $2883a5bab490bd30$var$R ? r.adoptedStyleSheets = t.map((e)=>e instanceof CSSStyleSheet ? e : e.styleSheet) : t.forEach((e)=>{
        let o = document.createElement("style"), i = $2883a5bab490bd30$var$N.litNonce;
        i !== void 0 && o.setAttribute("nonce", i), o.textContent = e.cssText, r.appendChild(o);
    });
}, $2883a5bab490bd30$var$O = $2883a5bab490bd30$var$R ? (r)=>r : (r)=>r instanceof CSSStyleSheet ? ((t)=>{
        let e = "";
        for (let o of t.cssRules)e += o.cssText;
        return $2883a5bab490bd30$var$et(e);
    })(r) : r;
var $2883a5bab490bd30$var$B, $2883a5bab490bd30$var$T = window, $2883a5bab490bd30$var$ot = $2883a5bab490bd30$var$T.trustedTypes, $2883a5bab490bd30$var$xt = $2883a5bab490bd30$var$ot ? $2883a5bab490bd30$var$ot.emptyScript : "", $2883a5bab490bd30$var$it = $2883a5bab490bd30$var$T.reactiveElementPolyfillSupport, $2883a5bab490bd30$var$I = {
    toAttribute (r, t) {
        switch(t){
            case Boolean:
                r = r ? $2883a5bab490bd30$var$xt : null;
                break;
            case Object:
            case Array:
                r = r == null ? r : JSON.stringify(r);
        }
        return r;
    },
    fromAttribute (r, t) {
        let e = r;
        switch(t){
            case Boolean:
                e = r !== null;
                break;
            case Number:
                e = r === null ? null : Number(r);
                break;
            case Object:
            case Array:
                try {
                    e = JSON.parse(r);
                } catch  {
                    e = null;
                }
        }
        return e;
    }
}, $2883a5bab490bd30$var$rt = (r, t)=>t !== r && (t == t || r == r), $2883a5bab490bd30$var$D = {
    attribute: !0,
    type: String,
    converter: $2883a5bab490bd30$var$I,
    reflect: !1,
    hasChanged: $2883a5bab490bd30$var$rt
}, $2883a5bab490bd30$var$V = "finalized", $2883a5bab490bd30$var$f = class extends HTMLElement {
    constructor(){
        super(), this._$Ei = new Map, this.isUpdatePending = !1, this.hasUpdated = !1, this._$El = null, this._$Eu();
    }
    static addInitializer(t) {
        var e;
        this.finalize(), ((e = this.h) !== null && e !== void 0 ? e : this.h = []).push(t);
    }
    static get observedAttributes() {
        this.finalize();
        let t = [];
        return this.elementProperties.forEach((e, o)=>{
            let i = this._$Ep(o, e);
            i !== void 0 && (this._$Ev.set(i, o), t.push(i));
        }), t;
    }
    static createProperty(t, e = $2883a5bab490bd30$var$D) {
        if (e.state && (e.attribute = !1), this.finalize(), this.elementProperties.set(t, e), !e.noAccessor && !this.prototype.hasOwnProperty(t)) {
            let o = typeof t == "symbol" ? Symbol() : "__" + t, i = this.getPropertyDescriptor(t, o, e);
            i !== void 0 && Object.defineProperty(this.prototype, t, i);
        }
    }
    static getPropertyDescriptor(t, e, o) {
        return {
            get () {
                return this[e];
            },
            set (i) {
                let n = this[t];
                this[e] = i, this.requestUpdate(t, n, o);
            },
            configurable: !0,
            enumerable: !0
        };
    }
    static getPropertyOptions(t) {
        return this.elementProperties.get(t) || $2883a5bab490bd30$var$D;
    }
    static finalize() {
        if (this.hasOwnProperty($2883a5bab490bd30$var$V)) return !1;
        this[$2883a5bab490bd30$var$V] = !0;
        let t = Object.getPrototypeOf(this);
        if (t.finalize(), t.h !== void 0 && (this.h = [
            ...t.h
        ]), this.elementProperties = new Map(t.elementProperties), this._$Ev = new Map, this.hasOwnProperty("properties")) {
            let e = this.properties, o = [
                ...Object.getOwnPropertyNames(e),
                ...Object.getOwnPropertySymbols(e)
            ];
            for (let i of o)this.createProperty(i, e[i]);
        }
        return this.elementStyles = this.finalizeStyles(this.styles), !0;
    }
    static finalizeStyles(t) {
        let e = [];
        if (Array.isArray(t)) {
            let o = new Set(t.flat(1 / 0).reverse());
            for (let i of o)e.unshift($2883a5bab490bd30$var$O(i));
        } else t !== void 0 && e.push($2883a5bab490bd30$var$O(t));
        return e;
    }
    static _$Ep(t, e) {
        let o = e.attribute;
        return o === !1 ? void 0 : typeof o == "string" ? o : typeof t == "string" ? t.toLowerCase() : void 0;
    }
    _$Eu() {
        var t;
        this._$E_ = new Promise((e)=>this.enableUpdating = e), this._$AL = new Map, this._$Eg(), this.requestUpdate(), (t = this.constructor.h) === null || t === void 0 || t.forEach((e)=>e(this));
    }
    addController(t) {
        var e, o;
        ((e = this._$ES) !== null && e !== void 0 ? e : this._$ES = []).push(t), this.renderRoot !== void 0 && this.isConnected && ((o = t.hostConnected) === null || o === void 0 || o.call(t));
    }
    removeController(t) {
        var e;
        (e = this._$ES) === null || e === void 0 || e.splice(this._$ES.indexOf(t) >>> 0, 1);
    }
    _$Eg() {
        this.constructor.elementProperties.forEach((t, e)=>{
            this.hasOwnProperty(e) && (this._$Ei.set(e, this[e]), delete this[e]);
        });
    }
    createRenderRoot() {
        var t;
        let e = (t = this.shadowRoot) !== null && t !== void 0 ? t : this.attachShadow(this.constructor.shadowRootOptions);
        return $2883a5bab490bd30$var$L(e, this.constructor.elementStyles), e;
    }
    connectedCallback() {
        var t;
        this.renderRoot === void 0 && (this.renderRoot = this.createRenderRoot()), this.enableUpdating(!0), (t = this._$ES) === null || t === void 0 || t.forEach((e)=>{
            var o;
            return (o = e.hostConnected) === null || o === void 0 ? void 0 : o.call(e);
        });
    }
    enableUpdating(t) {}
    disconnectedCallback() {
        var t;
        (t = this._$ES) === null || t === void 0 || t.forEach((e)=>{
            var o;
            return (o = e.hostDisconnected) === null || o === void 0 ? void 0 : o.call(e);
        });
    }
    attributeChangedCallback(t, e, o) {
        this._$AK(t, o);
    }
    _$EO(t, e, o = $2883a5bab490bd30$var$D) {
        var i;
        let n = this.constructor._$Ep(t, o);
        if (n !== void 0 && o.reflect === !0) {
            let s = (((i = o.converter) === null || i === void 0 ? void 0 : i.toAttribute) !== void 0 ? o.converter : $2883a5bab490bd30$var$I).toAttribute(e, o.type);
            this._$El = t, s == null ? this.removeAttribute(n) : this.setAttribute(n, s), this._$El = null;
        }
    }
    _$AK(t, e) {
        var o;
        let i = this.constructor, n = i._$Ev.get(t);
        if (n !== void 0 && this._$El !== n) {
            let s = i.getPropertyOptions(n), h = typeof s.converter == "function" ? {
                fromAttribute: s.converter
            } : ((o = s.converter) === null || o === void 0 ? void 0 : o.fromAttribute) !== void 0 ? s.converter : $2883a5bab490bd30$var$I;
            this._$El = n, this[n] = h.fromAttribute(e, s.type), this._$El = null;
        }
    }
    requestUpdate(t, e, o) {
        let i = !0;
        t !== void 0 && (((o = o || this.constructor.getPropertyOptions(t)).hasChanged || $2883a5bab490bd30$var$rt)(this[t], e) ? (this._$AL.has(t) || this._$AL.set(t, e), o.reflect === !0 && this._$El !== t && (this._$EC === void 0 && (this._$EC = new Map), this._$EC.set(t, o))) : i = !1), !this.isUpdatePending && i && (this._$E_ = this._$Ej());
    }
    async _$Ej() {
        this.isUpdatePending = !0;
        try {
            await this._$E_;
        } catch (e) {
            Promise.reject(e);
        }
        let t = this.scheduleUpdate();
        return t != null && await t, !this.isUpdatePending;
    }
    scheduleUpdate() {
        return this.performUpdate();
    }
    performUpdate() {
        var t;
        if (!this.isUpdatePending) return;
        this.hasUpdated, this._$Ei && (this._$Ei.forEach((i, n)=>this[n] = i), this._$Ei = void 0);
        let e = !1, o = this._$AL;
        try {
            e = this.shouldUpdate(o), e ? (this.willUpdate(o), (t = this._$ES) === null || t === void 0 || t.forEach((i)=>{
                var n;
                return (n = i.hostUpdate) === null || n === void 0 ? void 0 : n.call(i);
            }), this.update(o)) : this._$Ek();
        } catch (i) {
            throw e = !1, this._$Ek(), i;
        }
        e && this._$AE(o);
    }
    willUpdate(t) {}
    _$AE(t) {
        var e;
        (e = this._$ES) === null || e === void 0 || e.forEach((o)=>{
            var i;
            return (i = o.hostUpdated) === null || i === void 0 ? void 0 : i.call(o);
        }), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
    }
    _$Ek() {
        this._$AL = new Map, this.isUpdatePending = !1;
    }
    get updateComplete() {
        return this.getUpdateComplete();
    }
    getUpdateComplete() {
        return this._$E_;
    }
    shouldUpdate(t) {
        return !0;
    }
    update(t) {
        this._$EC !== void 0 && (this._$EC.forEach((e, o)=>this._$EO(o, this[o], e)), this._$EC = void 0), this._$Ek();
    }
    updated(t) {}
    firstUpdated(t) {}
};
$2883a5bab490bd30$var$f[$2883a5bab490bd30$var$V] = !0, $2883a5bab490bd30$var$f.elementProperties = new Map, $2883a5bab490bd30$var$f.elementStyles = [], $2883a5bab490bd30$var$f.shadowRootOptions = {
    mode: "open"
}, $2883a5bab490bd30$var$it == null || $2883a5bab490bd30$var$it({
    ReactiveElement: $2883a5bab490bd30$var$f
}), (($2883a5bab490bd30$var$B = $2883a5bab490bd30$var$T.reactiveElementVersions) !== null && $2883a5bab490bd30$var$B !== void 0 ? $2883a5bab490bd30$var$B : $2883a5bab490bd30$var$T.reactiveElementVersions = []).push("1.6.3");
var $2883a5bab490bd30$var$K, $2883a5bab490bd30$var$z = window, $2883a5bab490bd30$var$y = $2883a5bab490bd30$var$z.trustedTypes, $2883a5bab490bd30$var$st = $2883a5bab490bd30$var$y ? $2883a5bab490bd30$var$y.createPolicy("lit-html", {
    createHTML: (r)=>r
}) : void 0, $2883a5bab490bd30$var$q = "$lit$", $2883a5bab490bd30$var$g = `lit$${(Math.random() + "").slice(9)}$`, $2883a5bab490bd30$var$dt = "?" + $2883a5bab490bd30$var$g, $2883a5bab490bd30$var$yt = `<${$2883a5bab490bd30$var$dt}>`, $2883a5bab490bd30$var$m = document, $2883a5bab490bd30$var$k = ()=>$2883a5bab490bd30$var$m.createComment(""), $2883a5bab490bd30$var$C = (r)=>r === null || typeof r != "object" && typeof r != "function", $2883a5bab490bd30$var$ut = Array.isArray, $2883a5bab490bd30$var$_t = (r)=>$2883a5bab490bd30$var$ut(r) || typeof (r == null ? void 0 : r[Symbol.iterator]) == "function", $2883a5bab490bd30$var$W = `[ 	
\f\r]`, $2883a5bab490bd30$var$E = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, $2883a5bab490bd30$var$nt = /-->/g, $2883a5bab490bd30$var$lt = />/g, $2883a5bab490bd30$var$b = RegExp(`>|${$2883a5bab490bd30$var$W}(?:([^\\s"'>=/]+)(${$2883a5bab490bd30$var$W}*=${$2883a5bab490bd30$var$W}*(?:[^ 	
\f\r"'\`<>=]|("|')|))|$)`, "g"), $2883a5bab490bd30$var$at = /'/g, $2883a5bab490bd30$var$ht = /"/g, $2883a5bab490bd30$var$vt = /^(?:script|style|textarea|title)$/i, $2883a5bab490bd30$var$ft = (r)=>(t, ...e)=>({
            _$litType$: r,
            strings: t,
            values: e
        }), $2883a5bab490bd30$export$407448d2b89b1813 = $2883a5bab490bd30$var$ft(1), $2883a5bab490bd30$var$x = Symbol.for("lit-noChange"), $2883a5bab490bd30$var$d = Symbol.for("lit-nothing"), $2883a5bab490bd30$var$ct = new WeakMap, $2883a5bab490bd30$var$$ = $2883a5bab490bd30$var$m.createTreeWalker($2883a5bab490bd30$var$m, 129, null, !1);
function $2883a5bab490bd30$var$gt(r, t) {
    if (!Array.isArray(r) || !r.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return $2883a5bab490bd30$var$st !== void 0 ? $2883a5bab490bd30$var$st.createHTML(t) : t;
}
var $2883a5bab490bd30$var$At = (r, t)=>{
    let e = r.length - 1, o = [], i, n = t === 2 ? "<svg>" : "", s = $2883a5bab490bd30$var$E;
    for(let h = 0; h < e; h++){
        let l = r[h], a, c, p = -1, u = 0;
        for(; u < l.length && (s.lastIndex = u, c = s.exec(l), c !== null);)u = s.lastIndex, s === $2883a5bab490bd30$var$E ? c[1] === "!--" ? s = $2883a5bab490bd30$var$nt : c[1] !== void 0 ? s = $2883a5bab490bd30$var$lt : c[2] !== void 0 ? ($2883a5bab490bd30$var$vt.test(c[2]) && (i = RegExp("</" + c[2], "g")), s = $2883a5bab490bd30$var$b) : c[3] !== void 0 && (s = $2883a5bab490bd30$var$b) : s === $2883a5bab490bd30$var$b ? c[0] === ">" ? (s = i != null ? i : $2883a5bab490bd30$var$E, p = -1) : c[1] === void 0 ? p = -2 : (p = s.lastIndex - c[2].length, a = c[1], s = c[3] === void 0 ? $2883a5bab490bd30$var$b : c[3] === '"' ? $2883a5bab490bd30$var$ht : $2883a5bab490bd30$var$at) : s === $2883a5bab490bd30$var$ht || s === $2883a5bab490bd30$var$at ? s = $2883a5bab490bd30$var$b : s === $2883a5bab490bd30$var$nt || s === $2883a5bab490bd30$var$lt ? s = $2883a5bab490bd30$var$E : (s = $2883a5bab490bd30$var$b, i = void 0);
        let v = s === $2883a5bab490bd30$var$b && r[h + 1].startsWith("/>") ? " " : "";
        n += s === $2883a5bab490bd30$var$E ? l + $2883a5bab490bd30$var$yt : p >= 0 ? (o.push(a), l.slice(0, p) + $2883a5bab490bd30$var$q + l.slice(p) + $2883a5bab490bd30$var$g + v) : l + $2883a5bab490bd30$var$g + (p === -2 ? (o.push(void 0), h) : v);
    }
    return [
        $2883a5bab490bd30$var$gt(r, n + (r[e] || "<?>") + (t === 2 ? "</svg>" : "")),
        o
    ];
}, $2883a5bab490bd30$var$U = class r {
    constructor({ strings: t, _$litType$: e }, o){
        let i;
        this.parts = [];
        let n = 0, s = 0, h = t.length - 1, l = this.parts, [a, c] = $2883a5bab490bd30$var$At(t, e);
        if (this.el = r.createElement(a, o), $2883a5bab490bd30$var$$.currentNode = this.el.content, e === 2) {
            let p = this.el.content, u = p.firstChild;
            u.remove(), p.append(...u.childNodes);
        }
        for(; (i = $2883a5bab490bd30$var$$.nextNode()) !== null && l.length < h;){
            if (i.nodeType === 1) {
                if (i.hasAttributes()) {
                    let p = [];
                    for (let u of i.getAttributeNames())if (u.endsWith($2883a5bab490bd30$var$q) || u.startsWith($2883a5bab490bd30$var$g)) {
                        let v = c[s++];
                        if (p.push(u), v !== void 0) {
                            let mt = i.getAttribute(v.toLowerCase() + $2883a5bab490bd30$var$q).split($2883a5bab490bd30$var$g), H = /([.?@])?(.*)/.exec(v);
                            l.push({
                                type: 1,
                                index: n,
                                name: H[2],
                                strings: mt,
                                ctor: H[1] === "." ? $2883a5bab490bd30$var$F : H[1] === "?" ? $2883a5bab490bd30$var$Z : H[1] === "@" ? $2883a5bab490bd30$var$G : $2883a5bab490bd30$var$A
                            });
                        } else l.push({
                            type: 6,
                            index: n
                        });
                    }
                    for (let u of p)i.removeAttribute(u);
                }
                if ($2883a5bab490bd30$var$vt.test(i.tagName)) {
                    let p = i.textContent.split($2883a5bab490bd30$var$g), u = p.length - 1;
                    if (u > 0) {
                        i.textContent = $2883a5bab490bd30$var$y ? $2883a5bab490bd30$var$y.emptyScript : "";
                        for(let v = 0; v < u; v++)i.append(p[v], $2883a5bab490bd30$var$k()), $2883a5bab490bd30$var$$.nextNode(), l.push({
                            type: 2,
                            index: ++n
                        });
                        i.append(p[u], $2883a5bab490bd30$var$k());
                    }
                }
            } else if (i.nodeType === 8) {
                if (i.data === $2883a5bab490bd30$var$dt) l.push({
                    type: 2,
                    index: n
                });
                else {
                    let p = -1;
                    for(; (p = i.data.indexOf($2883a5bab490bd30$var$g, p + 1)) !== -1;)l.push({
                        type: 7,
                        index: n
                    }), p += $2883a5bab490bd30$var$g.length - 1;
                }
            }
            n++;
        }
    }
    static createElement(t, e) {
        let o = $2883a5bab490bd30$var$m.createElement("template");
        return o.innerHTML = t, o;
    }
};
function $2883a5bab490bd30$var$_(r, t, e = r, o) {
    var i, n, s, h;
    if (t === $2883a5bab490bd30$var$x) return t;
    let l = o !== void 0 ? (i = e._$Co) === null || i === void 0 ? void 0 : i[o] : e._$Cl, a = $2883a5bab490bd30$var$C(t) ? void 0 : t._$litDirective$;
    return (l == null ? void 0 : l.constructor) !== a && ((n = l == null ? void 0 : l._$AO) === null || n === void 0 || n.call(l, !1), a === void 0 ? l = void 0 : (l = new a(r), l._$AT(r, e, o)), o !== void 0 ? ((s = (h = e)._$Co) !== null && s !== void 0 ? s : h._$Co = [])[o] = l : e._$Cl = l), l !== void 0 && (t = $2883a5bab490bd30$var$_(r, l._$AS(r, t.values), l, o)), t;
}
var $2883a5bab490bd30$var$J = class {
    constructor(t, e){
        this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = e;
    }
    get parentNode() {
        return this._$AM.parentNode;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    u(t) {
        var e;
        let { el: { content: o }, parts: i } = this._$AD, n = ((e = t == null ? void 0 : t.creationScope) !== null && e !== void 0 ? e : $2883a5bab490bd30$var$m).importNode(o, !0);
        $2883a5bab490bd30$var$$.currentNode = n;
        let s = $2883a5bab490bd30$var$$.nextNode(), h = 0, l = 0, a = i[0];
        for(; a !== void 0;){
            if (h === a.index) {
                let c;
                a.type === 2 ? c = new $2883a5bab490bd30$var$P(s, s.nextSibling, this, t) : a.type === 1 ? c = new a.ctor(s, a.name, a.strings, this, t) : a.type === 6 && (c = new $2883a5bab490bd30$var$Q(s, this, t)), this._$AV.push(c), a = i[++l];
            }
            h !== (a == null ? void 0 : a.index) && (s = $2883a5bab490bd30$var$$.nextNode(), h++);
        }
        return $2883a5bab490bd30$var$$.currentNode = $2883a5bab490bd30$var$m, n;
    }
    v(t) {
        let e = 0;
        for (let o of this._$AV)o !== void 0 && (o.strings !== void 0 ? (o._$AI(t, o, e), e += o.strings.length - 2) : o._$AI(t[e])), e++;
    }
}, $2883a5bab490bd30$var$P = class r {
    constructor(t, e, o, i){
        var n;
        this.type = 2, this._$AH = $2883a5bab490bd30$var$d, this._$AN = void 0, this._$AA = t, this._$AB = e, this._$AM = o, this.options = i, this._$Cp = (n = i == null ? void 0 : i.isConnected) === null || n === void 0 || n;
    }
    get _$AU() {
        var t, e;
        return (e = (t = this._$AM) === null || t === void 0 ? void 0 : t._$AU) !== null && e !== void 0 ? e : this._$Cp;
    }
    get parentNode() {
        let t = this._$AA.parentNode, e = this._$AM;
        return e !== void 0 && (t == null ? void 0 : t.nodeType) === 11 && (t = e.parentNode), t;
    }
    get startNode() {
        return this._$AA;
    }
    get endNode() {
        return this._$AB;
    }
    _$AI(t, e = this) {
        t = $2883a5bab490bd30$var$_(this, t, e), $2883a5bab490bd30$var$C(t) ? t === $2883a5bab490bd30$var$d || t == null || t === "" ? (this._$AH !== $2883a5bab490bd30$var$d && this._$AR(), this._$AH = $2883a5bab490bd30$var$d) : t !== this._$AH && t !== $2883a5bab490bd30$var$x && this._(t) : t._$litType$ !== void 0 ? this.g(t) : t.nodeType !== void 0 ? this.$(t) : $2883a5bab490bd30$var$_t(t) ? this.T(t) : this._(t);
    }
    k(t) {
        return this._$AA.parentNode.insertBefore(t, this._$AB);
    }
    $(t) {
        this._$AH !== t && (this._$AR(), this._$AH = this.k(t));
    }
    _(t) {
        this._$AH !== $2883a5bab490bd30$var$d && $2883a5bab490bd30$var$C(this._$AH) ? this._$AA.nextSibling.data = t : this.$($2883a5bab490bd30$var$m.createTextNode(t)), this._$AH = t;
    }
    g(t) {
        var e;
        let { values: o, _$litType$: i } = t, n = typeof i == "number" ? this._$AC(t) : (i.el === void 0 && (i.el = $2883a5bab490bd30$var$U.createElement($2883a5bab490bd30$var$gt(i.h, i.h[0]), this.options)), i);
        if (((e = this._$AH) === null || e === void 0 ? void 0 : e._$AD) === n) this._$AH.v(o);
        else {
            let s = new $2883a5bab490bd30$var$J(n, this), h = s.u(this.options);
            s.v(o), this.$(h), this._$AH = s;
        }
    }
    _$AC(t) {
        let e = $2883a5bab490bd30$var$ct.get(t.strings);
        return e === void 0 && $2883a5bab490bd30$var$ct.set(t.strings, e = new $2883a5bab490bd30$var$U(t)), e;
    }
    T(t) {
        $2883a5bab490bd30$var$ut(this._$AH) || (this._$AH = [], this._$AR());
        let e = this._$AH, o, i = 0;
        for (let n of t)i === e.length ? e.push(o = new r(this.k($2883a5bab490bd30$var$k()), this.k($2883a5bab490bd30$var$k()), this, this.options)) : o = e[i], o._$AI(n), i++;
        i < e.length && (this._$AR(o && o._$AB.nextSibling, i), e.length = i);
    }
    _$AR(t = this._$AA.nextSibling, e) {
        var o;
        for((o = this._$AP) === null || o === void 0 || o.call(this, !1, !0, e); t && t !== this._$AB;){
            let i = t.nextSibling;
            t.remove(), t = i;
        }
    }
    setConnected(t) {
        var e;
        this._$AM === void 0 && (this._$Cp = t, (e = this._$AP) === null || e === void 0 || e.call(this, t));
    }
}, $2883a5bab490bd30$var$A = class {
    constructor(t, e, o, i, n){
        this.type = 1, this._$AH = $2883a5bab490bd30$var$d, this._$AN = void 0, this.element = t, this.name = e, this._$AM = i, this.options = n, o.length > 2 || o[0] !== "" || o[1] !== "" ? (this._$AH = Array(o.length - 1).fill(new String), this.strings = o) : this._$AH = $2883a5bab490bd30$var$d;
    }
    get tagName() {
        return this.element.tagName;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t, e = this, o, i) {
        let n = this.strings, s = !1;
        if (n === void 0) t = $2883a5bab490bd30$var$_(this, t, e, 0), s = !$2883a5bab490bd30$var$C(t) || t !== this._$AH && t !== $2883a5bab490bd30$var$x, s && (this._$AH = t);
        else {
            let h = t, l, a;
            for(t = n[0], l = 0; l < n.length - 1; l++)a = $2883a5bab490bd30$var$_(this, h[o + l], e, l), a === $2883a5bab490bd30$var$x && (a = this._$AH[l]), s || (s = !$2883a5bab490bd30$var$C(a) || a !== this._$AH[l]), a === $2883a5bab490bd30$var$d ? t = $2883a5bab490bd30$var$d : t !== $2883a5bab490bd30$var$d && (t += (a != null ? a : "") + n[l + 1]), this._$AH[l] = a;
        }
        s && !i && this.j(t);
    }
    j(t) {
        t === $2883a5bab490bd30$var$d ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, t != null ? t : "");
    }
}, $2883a5bab490bd30$var$F = class extends $2883a5bab490bd30$var$A {
    constructor(){
        super(...arguments), this.type = 3;
    }
    j(t) {
        this.element[this.name] = t === $2883a5bab490bd30$var$d ? void 0 : t;
    }
}, $2883a5bab490bd30$var$wt = $2883a5bab490bd30$var$y ? $2883a5bab490bd30$var$y.emptyScript : "", $2883a5bab490bd30$var$Z = class extends $2883a5bab490bd30$var$A {
    constructor(){
        super(...arguments), this.type = 4;
    }
    j(t) {
        t && t !== $2883a5bab490bd30$var$d ? this.element.setAttribute(this.name, $2883a5bab490bd30$var$wt) : this.element.removeAttribute(this.name);
    }
}, $2883a5bab490bd30$var$G = class extends $2883a5bab490bd30$var$A {
    constructor(t, e, o, i, n){
        super(t, e, o, i, n), this.type = 5;
    }
    _$AI(t, e = this) {
        var o;
        if ((t = (o = $2883a5bab490bd30$var$_(this, t, e, 0)) !== null && o !== void 0 ? o : $2883a5bab490bd30$var$d) === $2883a5bab490bd30$var$x) return;
        let i = this._$AH, n = t === $2883a5bab490bd30$var$d && i !== $2883a5bab490bd30$var$d || t.capture !== i.capture || t.once !== i.once || t.passive !== i.passive, s = t !== $2883a5bab490bd30$var$d && (i === $2883a5bab490bd30$var$d || n);
        n && this.element.removeEventListener(this.name, this, i), s && this.element.addEventListener(this.name, this, t), this._$AH = t;
    }
    handleEvent(t) {
        var e, o;
        typeof this._$AH == "function" ? this._$AH.call((o = (e = this.options) === null || e === void 0 ? void 0 : e.host) !== null && o !== void 0 ? o : this.element, t) : this._$AH.handleEvent(t);
    }
}, $2883a5bab490bd30$var$Q = class {
    constructor(t, e, o){
        this.element = t, this.type = 6, this._$AN = void 0, this._$AM = e, this.options = o;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t) {
        $2883a5bab490bd30$var$_(this, t);
    }
};
var $2883a5bab490bd30$var$pt = $2883a5bab490bd30$var$z.litHtmlPolyfillSupport;
$2883a5bab490bd30$var$pt == null || $2883a5bab490bd30$var$pt($2883a5bab490bd30$var$U, $2883a5bab490bd30$var$P), (($2883a5bab490bd30$var$K = $2883a5bab490bd30$var$z.litHtmlVersions) !== null && $2883a5bab490bd30$var$K !== void 0 ? $2883a5bab490bd30$var$K : $2883a5bab490bd30$var$z.litHtmlVersions = []).push("2.8.0");
var $2883a5bab490bd30$var$bt = (r, t, e)=>{
    var o, i;
    let n = (o = e == null ? void 0 : e.renderBefore) !== null && o !== void 0 ? o : t, s = n._$litPart$;
    if (s === void 0) {
        let h = (i = e == null ? void 0 : e.renderBefore) !== null && i !== void 0 ? i : null;
        n._$litPart$ = s = new $2883a5bab490bd30$var$P(t.insertBefore($2883a5bab490bd30$var$k(), h), h, void 0, e != null ? e : {});
    }
    return s._$AI(r), s;
};
var $2883a5bab490bd30$var$X, $2883a5bab490bd30$var$Y;
var $2883a5bab490bd30$export$8b22cf2602fb60ce = class extends $2883a5bab490bd30$var$f {
    constructor(){
        super(...arguments), this.renderOptions = {
            host: this
        }, this._$Do = void 0;
    }
    createRenderRoot() {
        var t, e;
        let o = super.createRenderRoot();
        return (t = (e = this.renderOptions).renderBefore) !== null && t !== void 0 || (e.renderBefore = o.firstChild), o;
    }
    update(t) {
        let e = this.render();
        this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this._$Do = $2883a5bab490bd30$var$bt(e, this.renderRoot, this.renderOptions);
    }
    connectedCallback() {
        var t;
        super.connectedCallback(), (t = this._$Do) === null || t === void 0 || t.setConnected(!0);
    }
    disconnectedCallback() {
        var t;
        super.disconnectedCallback(), (t = this._$Do) === null || t === void 0 || t.setConnected(!1);
    }
    render() {
        return $2883a5bab490bd30$var$x;
    }
};
$2883a5bab490bd30$export$8b22cf2602fb60ce.finalized = !0, $2883a5bab490bd30$export$8b22cf2602fb60ce._$litElement$ = !0, ($2883a5bab490bd30$var$X = globalThis.litElementHydrateSupport) === null || $2883a5bab490bd30$var$X === void 0 || $2883a5bab490bd30$var$X.call(globalThis, {
    LitElement: $2883a5bab490bd30$export$8b22cf2602fb60ce
});
var $2883a5bab490bd30$var$$t = globalThis.litElementPolyfillSupport;
$2883a5bab490bd30$var$$t == null || $2883a5bab490bd30$var$$t({
    LitElement: $2883a5bab490bd30$export$8b22cf2602fb60ce
});
(($2883a5bab490bd30$var$Y = globalThis.litElementVersions) !== null && $2883a5bab490bd30$var$Y !== void 0 ? $2883a5bab490bd30$var$Y : globalThis.litElementVersions = []).push("3.3.3");
var $2883a5bab490bd30$export$db3b6bfb95261072 = $2883a5bab490bd30$var$j`
  @font-face {
    font-family: 'Karla';
    font-weight: regular;
    src: url('./fonts/Karla-regular.woff') format('woff');
  }

  * {
    box-sizing: border-box;
  }

  :host {
    --lottie-player-toolbar-height: 35px;
    --lottie-player-toolbar-background-color: transparent;
    --lottie-player-toolbar-hover-background-color: #f3f6f8;
    --lottie-player-toolbar-icon-color: #20272c;
    --lottie-player-toolbar-icon-hover-color: #f3f6f8;
    --lottie-player-toolbar-icon-active-color: #00ddb3;
    --lottie-player-seeker-track-color: #00ddb3;
    --lottie-player-seeker-accent-color: #00c1a2;
    --lottie-player-seeker-thumb-color: #00c1a2;
    --lottie-player-options-separator: #d9e0e6;

    display: block;
    width: 100%;
    height: 100%;

    font-family: 'Karla', sans-serif;
    font-style: normal;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .active {
    color: var(--lottie-player-toolbar-icon-active-color) !important;
  }

  .main {
    position: relative;
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
  }

  .animation {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
  }
  .animation.controls {
    height: calc(100% - var(--lottie-player-toolbar-height));
  }

  .toolbar {
    display: flex;
    align-items: center;
    justify-items: center;
    background-color: var(--lottie-player-toolbar-background-color);
    margin: 0 8px;
    height: var(--lottie-player-toolbar-height);
  }

  .btn-spacing-left {
    margin-right: 4px;
    margin-left: 8px;
  }

  .btn-spacing-center {
    margin-right: 4px;
    margin-left: 4px;
  }

  .btn-spacing-right {
    margin-right: 8px;
    margin-left: 4px;
  }

  .toolbar button {
    color: #20272c;
    cursor: pointer;
    fill: var(--lottie-player-toolbar-icon-color);
    display: flex;
    background: none;
    border: 0px;
    border-radius: 4px;
    padding: 4px;
    outline: none;
    width: 24px;
    height: 24px;
    align-items: center;
  }

  .toolbar button:hover {
    background-color: var(--lottie-player-toolbar-icon-hover-color);
    border-style: solid;
    border-radius: 2px;
  }

  .toolbar button.active {
    fill: var(--lottie-player-toolbar-icon-active-color);
  }

  .toolbar button.active:hover {
    fill: var(--lottie-player-toolbar-icon-hover-color);
    border-radius: 4px;
  }

  .toolbar button:focus-visible {
    outline: 2px solid var(--lottie-player-toolbar-icon-active-color);
    border-radius: 4px;
    box-sizing: border-box;
  }

  .toolbar button svg {
    width: 16px;
    height: 16px;
  }

  .toolbar button.disabled svg {
    display: none;
  }

  .popover {
    position: absolute;
    bottom: 40px;
    left: calc(100% - 239px);
    width: 224px;
    min-height: 84px;
    max-height: 300px;
    background-color: #ffffff;
    box-shadow: 0px 8px 48px 0px rgba(243, 246, 248, 0.15), 0px 8px 16px 0px rgba(61, 72, 83, 0.16),
      0px 0px 1px 0px rgba(61, 72, 83, 0.36);
    border-radius: 8px;
    padding: 8px;
    z-index: 100;
    overflow-y: scroll;
    scrollbar-width: none;
  }
  .popover:focus-visible {
    outline: 2px solid var(--lottie-player-toolbar-icon-active-color);
    border-radius: 4px;
    box-sizing: border-box;
  }

  .popover::-webkit-scrollbar {
    width: 0px;
  }

  .popover-button {
    background: none;
    border: none;
    font-family: inherit;
    width: 100%;
    flex-direction: row;
    cursor: pointer;
    height: 32px;
    color: #20272c;
    justify-content: space-between;
    display: flex;
    padding: 4px 8px;
    align-items: flex-start;
    gap: 8px;
    align-self: stretch;
    border-radius: 4px;
  }

  .popover-button:focus-visible {
    outline: 2px solid var(--lottie-player-toolbar-icon-active-color);
    border-radius: 4px;
    box-sizing: border-box;
  }

  .popover-button:hover {
    background-color: var(--lottie-player-toolbar-hover-background-color);
  }

  .popover-button-text {
    display: flex;
    color: #20272c;
    flex-direction: column;
    align-self: stretch;
    justify-content: center;
    font-family: inherit;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    letter-spacing: -0.28px;
  }

  .reset-btn {
    font-size: 12px;
    cursor: pointer;
    font-family: inherit;
    background: none;
    border: none;
    font-weight: 400;
    line-height: 18px;
    letter-spacing: 0em;
    text-align: left;
    color: #63727e;
    padding: 0;
    width: 31px;
    height: 18px;
  }
  .reset-btn:focus-visible {
    outline: 2px solid var(--lottie-player-toolbar-icon-active-color);
    border-radius: 4px;
    box-sizing: border-box;
  }
  .reset-btn:hover {
    color: #20272c;
  }

  .option-title-button {
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 32px;
    align-items: center;
    gap: 4px;
    align-self: stretch;
    cursor: pointer;
    color: var(--lottie-player-toolbar-icon-color);
    border: none;
    background: none;
    padding: 4px;
    font-family: inherit;
    font-size: 16px;
    font-weight: 700;
    line-height: 150%;
    letter-spacing: -0.32px;
  }
  .option-title-button.themes {
    width: auto;
    padding: 0;
  }
  .option-title-button:hover {
    background-color: var(--lottie-player-toolbar-icon-hover-color);
  }

  .option-title-themes-row {
    display: flex;
    align-items: center;
    gap: 8px;
    flex: 1 0 0;
  }
  .option-title-themes-row:hover {
    background-color: var(--lottie-player-toolbar-icon-hover-color);
  }

  .option-title-button:focus-visible {
    outline: 2px solid var(--lottie-player-toolbar-icon-active-color);
    border-radius: 4px;
    box-sizing: border-box;
  }

  .option-title-text {
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 150%;
    letter-spacing: -0.32px;
  }

  .option-title-separator {
    margin: 8px -8px;
    border-bottom: 1px solid var(--lottie-player-options-separator);
  }

  .option-title-chevron {
    display: flex;
    padding: 4px;
    border-radius: 8px;
    justify-content: center;
    align-items: center;
    gap: 8px;
  }

  .option-row {
    display: flex;
    flex-direction: column;
  }
  .option-row > ul {
    padding: 0;
    margin: 0;
  }

  .option-button {
    width: 100%;
    background: none;
    border: none;
    font-family: inherit;
    display: flex;
    padding: 4px 8px;
    color: #20272c;
    overflow: hidden;
    align-items: center;
    gap: 8px;
    align-self: stretch;
    cursor: pointer;
    height: 32px;
    font-family: inherit;
    font-size: 14px;
    border-radius: 4px;
  }
  .option-button:hover {
    background-color: var(--lottie-player-toolbar-hover-background-color);
  }
  .option-button:focus-visible {
    outline: 2px solid var(--lottie-player-toolbar-icon-active-color);
    border-radius: 4px;
    box-sizing: border-box;
  }

  .option-tick {
    display: flex;
    width: 24px;
    height: 24px;
    align-items: flex-start;
    gap: 8px;
  }

  .seeker {
    height: 4px;
    width: 95%;
    outline: none;
    -webkit-appearance: none;
    -moz-apperance: none;
    border-radius: 9999px;
    cursor: pointer;
    background-image: linear-gradient(
      to right,
      rgb(0, 221, 179) calc(var(--seeker) * 1%),
      rgb(217, 224, 230) calc(var(--seeker) * 1%)
    );
  }
  .seeker.to-left {
    background-image: linear-gradient(
      to right,
      rgb(217, 224, 230) calc(var(--seeker) * 1%),
      rgb(0, 221, 179) calc(var(--seeker) * 1%)
    );
  }
  .seeker::-webkit-slider-runnable-track:focus-visible {
    color: #f07167;
    accent-color: #00ddb3;
  }

  .seeker::-webkit-slider-runnable-track {
    width: 100%;
    height: 5px;
    cursor: pointer;
  }
  .seeker::-webkit-slider-thumb {
    -webkit-appearance: none;
    height: 16px;
    width: 16px;
    border-radius: 50%;
    background: var(--lottie-player-seeker-thumb-color);
    cursor: pointer;
    margin-top: -5px;
  }
  .seeker:focus-visible::-webkit-slider-thumb {
    background: var(--lottie-player-seeker-thumb-color);
    outline: 2px solid var(--lottie-player-seeker-track-color);
    border: 1.5px solid #ffffff;
  }
  .seeker::-webkit-slider-thumb:hover {
    background: #019d91;
  }
  .seeker::-moz-range-thumb {
    appearance: none;
    height: 16px;
    width: 16px;
    border-radius: 50%;
    background: var(--lottie-player-seeker-thumb-color);
    cursor: pointer;
    margin-top: -5px;
    border-color: transparent;
  }
  .seeker:focus-visible::-moz-range-thumb {
    background: var(--lottie-player-seeker-thumb-color);
    outline: 2px solid var(--lottie-player-seeker-track-color);
    border: 1.5px solid #ffffff;
  }

  .error {
    display: flex;
    justify-content: center;
    margin: auto;
    height: 100%;
    align-items: center;
  }
`; /*! Bundled license information:

@lit/reactive-element/css-tag.js:
  (**
   * @license
   * Copyright 2019 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

@lit/reactive-element/reactive-element.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

lit-html/lit-html.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

lit-element/lit-element.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

lit-html/is-server.js:
  (**
   * @license
   * Copyright 2022 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)
*/ 
 //# sourceMappingURL=out.js.map



var $6hxRz = parcelRequire("6hxRz");
parcelRequire("g90QB");

var $bL0Ij = parcelRequire("bL0Ij");
var $995049a942ccbcb3$var$M = (r, t)=>t.kind === "method" && t.descriptor && !("value" in t.descriptor) ? {
        ...t,
        finisher (e) {
            e.createProperty(t.key, r);
        }
    } : {
        kind: "field",
        key: Symbol(),
        placement: "own",
        descriptor: {},
        originalKey: t.key,
        initializer () {
            typeof t.initializer == "function" && (this[t.key] = t.initializer.call(this));
        },
        finisher (e) {
            e.createProperty(t.key, r);
        }
    }, $995049a942ccbcb3$var$x = (r, t, e)=>{
    t.constructor.createProperty(e, r);
};
function $995049a942ccbcb3$var$p(r) {
    return (t, e)=>e !== void 0 ? $995049a942ccbcb3$var$x(r, t, e) : $995049a942ccbcb3$var$M(r, t);
}
function $995049a942ccbcb3$var$k(r) {
    return $995049a942ccbcb3$var$p({
        ...r,
        state: !0
    });
}
var $995049a942ccbcb3$var$v = ({ finisher: r, descriptor: t })=>(e, i)=>{
        var n;
        if (i === void 0) {
            let l = (n = e.originalKey) !== null && n !== void 0 ? n : e.key, h = t != null ? {
                kind: "method",
                placement: "prototype",
                key: l,
                descriptor: t(e.key)
            } : {
                ...e,
                key: l
            };
            return r != null && (h.finisher = function(b) {
                r(b, l);
            }), h;
        }
        {
            let l = e.constructor;
            t !== void 0 && Object.defineProperty(e, i, t(i)), r == null || r(l, i);
        }
    };
function $995049a942ccbcb3$var$O(r, t) {
    return $995049a942ccbcb3$var$v({
        descriptor: (e)=>{
            let i = {
                get () {
                    var n, l;
                    return (l = (n = this.renderRoot) === null || n === void 0 ? void 0 : n.querySelector(r)) !== null && l !== void 0 ? l : null;
                },
                enumerable: !0,
                configurable: !0
            };
            if (t) {
                let n = typeof e == "symbol" ? Symbol() : "__" + e;
                i.get = function() {
                    var l, h;
                    return this[n] === void 0 && (this[n] = (h = (l = this.renderRoot) === null || l === void 0 ? void 0 : l.querySelector(r)) !== null && h !== void 0 ? h : null), this[n];
                };
            }
            return i;
        }
    });
}
var $995049a942ccbcb3$var$L;
(($995049a942ccbcb3$var$L = window.HTMLSlotElement) === null || $995049a942ccbcb3$var$L === void 0 ? void 0 : $995049a942ccbcb3$var$L.prototype.assignedElements) != null ? (r, t)=>r.assignedElements(t) : (r, t)=>r.assignedNodes(t).filter((e)=>e.nodeType === Node.ELEMENT_NODE);
var $995049a942ccbcb3$var$I = {
    name: "@dotlottie/player-component",
    version: "2.7.5",
    description: "dotLottie animation player web component.",
    repository: "https://github.com/dotlottie/player-component.git",
    homepage: "https://dotlottie.com/players",
    bugs: "https://github.com/dotlottie/player-component/issues",
    author: "Jawish Hameed <jawish@lottiefiles.com>",
    license: "MIT",
    main: "dist/dotlottie-player.js",
    module: "dist/dotlottie-player.mjs",
    types: "dist/dotlottie-player.d.ts",
    files: [
        "dist"
    ],
    keywords: [
        "dotlottie",
        "animation",
        "web component",
        "component",
        "lit-element",
        "player"
    ],
    scripts: {
        build: "tsup",
        "cypress:open": "cypress open --component",
        dev: "tsup --watch",
        lint: "eslint .",
        "lint:fix": "eslint --fix",
        test: "cypress run --component",
        "type-check": "tsc --noEmit"
    },
    dependencies: {
        "@dotlottie/common": "workspace:*",
        lit: "^2.7.5"
    },
    devDependencies: {
        "@vitejs/plugin-legacy": "^4.1.0",
        "axe-core": "^4.7.2",
        cypress: "^12.11.0",
        "cypress-axe": "^1.4.0",
        "cypress-ct-lit": "^0.3.2",
        "lottie-web": "^5.12.2",
        terser: "^5.19.0",
        tsup: "^7.2.0",
        typescript: "^4.7.4",
        vite: "^4.3.9"
    },
    publishConfig: {
        access: "public"
    },
    browserslist: [
        "> 3%"
    ]
};
var $995049a942ccbcb3$var$T = "dotlottie-player";
var $995049a942ccbcb3$export$a44c8d2ddace26de = class extends (0, $2883a5bab490bd30$export$8b22cf2602fb60ce) {
    defaultTheme = "";
    container;
    playMode = (0, $6hxRz.g).Normal;
    autoplay = !1;
    background = "transparent";
    controls = !1;
    direction = 1;
    hover = !1;
    loop;
    renderer = "svg";
    speed = 1;
    src;
    intermission = 0;
    activeAnimationId = null;
    light = !1;
    worker = !1;
    activeStateId;
    _seeker = 0;
    _dotLottieCommonPlayer;
    _io;
    _loop;
    _renderer = "svg";
    _unsubscribeListeners;
    _hasMultipleAnimations = !1;
    _hasMultipleThemes = !1;
    _hasMultipleStates = !1;
    _popoverIsOpen = !1;
    _animationsTabIsOpen = !1;
    _statesTabIsOpen = !1;
    _styleTabIsOpen = !1;
    _themesForCurrentAnimation = [];
    _statesForCurrentAnimation = [];
    _parseLoop(t) {
        let e = parseInt(t, 10);
        return Number.isInteger(e) && e > 0 ? (this._loop = e, e) : typeof t == "string" && [
            "true",
            "false"
        ].includes(t) ? (this._loop = t === "true", this._loop) : ((0, $6hxRz.c)("loop must be a positive integer or a boolean"), !1);
    }
    _handleSeekChange(t) {
        let e = t.currentTarget;
        try {
            let i = parseInt(e.value, 10);
            if (!this._dotLottieCommonPlayer) return;
            let n = i / 100 * this._dotLottieCommonPlayer.totalFrames;
            this.seek(n);
        } catch  {
            throw (0, $6hxRz.a)("Error while seeking animation");
        }
    }
    _initListeners() {
        let t = this._dotLottieCommonPlayer;
        if (t === void 0) {
            (0, $6hxRz.c)("player not initialized - cannot add event listeners", "dotlottie-player-component");
            return;
        }
        this._unsubscribeListeners = t.state.subscribe((e$1, i)=>{
            this._seeker = e$1.seeker, this.requestUpdate(), i.currentState !== e$1.currentState && this.dispatchEvent(new CustomEvent(e$1.currentState)), this.dispatchEvent(new CustomEvent((0, $6hxRz.e).Frame, {
                detail: {
                    frame: e$1.frame,
                    seeker: e$1.seeker
                }
            })), this.dispatchEvent(new CustomEvent((0, $6hxRz.e).VisibilityChange, {
                detail: {
                    visibilityPercentage: e$1.visibilityPercentage
                }
            }));
        }), t.addEventListener("complete", ()=>{
            this.dispatchEvent(new CustomEvent((0, $6hxRz.e).Complete));
        }), t.addEventListener("loopComplete", ()=>{
            this.dispatchEvent(new CustomEvent((0, $6hxRz.e).LoopComplete));
        }), t.addEventListener("DOMLoaded", ()=>{
            let e$1 = this.getManifest();
            e$1 && e$1.themes && (this._themesForCurrentAnimation = e$1.themes.filter((i)=>i.animations.includes(this.getCurrentAnimationId() || ""))), e$1 && e$1.states && (this._hasMultipleStates = e$1.states.length > 0, this._statesForCurrentAnimation = [], e$1.states.forEach((i)=>{
                this._statesForCurrentAnimation.push(i);
            })), this.dispatchEvent(new CustomEvent((0, $6hxRz.e).Ready));
        }), t.addEventListener("data_ready", ()=>{
            this.dispatchEvent(new CustomEvent((0, $6hxRz.e).DataReady));
        }), t.addEventListener("data_failed", ()=>{
            this.dispatchEvent(new CustomEvent((0, $6hxRz.e).DataFail));
        }), window && window.addEventListener("click", (e)=>this._clickOutListener(e));
    }
    async load(t, e, i) {
        if (!this.shadowRoot) return;
        this._dotLottieCommonPlayer && this._dotLottieCommonPlayer.destroy(), this._dotLottieCommonPlayer = new (0, $6hxRz.j)(t, this.container, {
            rendererSettings: e != null ? e : {
                scaleMode: "noScale",
                clearCanvas: !0,
                progressiveLoad: !0,
                hideOnTransparent: !0
            },
            hover: this.hasAttribute("hover") ? this.hover : void 0,
            renderer: this.hasAttribute("renderer") ? this._renderer : void 0,
            loop: this.hasAttribute("loop") ? this._loop : void 0,
            direction: this.hasAttribute("direction") ? this.direction === 1 ? 1 : -1 : void 0,
            speed: this.hasAttribute("speed") ? this.speed : void 0,
            intermission: this.hasAttribute("intermission") ? Number(this.intermission) : void 0,
            playMode: this.hasAttribute("playMode") ? this.playMode : void 0,
            autoplay: this.hasAttribute("autoplay") ? this.autoplay : void 0,
            activeAnimationId: this.hasAttribute("activeAnimationId") ? this.activeAnimationId : void 0,
            defaultTheme: this.hasAttribute("defaultTheme") ? this.defaultTheme : void 0,
            light: this.light,
            worker: this.worker,
            activeStateId: this.hasAttribute("activeStateId") ? this.activeStateId : void 0
        }), await this._dotLottieCommonPlayer.load(i);
        let n = this.getManifest();
        this._hasMultipleAnimations = this.animationCount() > 1, n && (n.themes && (this._themesForCurrentAnimation = n.themes.filter((l)=>l.animations.includes(this.getCurrentAnimationId() || "")), this._hasMultipleThemes = n.themes.length > 0), n.states && (this._hasMultipleStates = n.states.length > 0, this._statesForCurrentAnimation = [], n.states.forEach((l)=>{
            this._statesForCurrentAnimation.push(l);
        }))), this._initListeners();
    }
    getCurrentAnimationId() {
        var t;
        return (t = this._dotLottieCommonPlayer) == null ? void 0 : t.currentAnimationId;
    }
    animationCount() {
        var t;
        return this._dotLottieCommonPlayer && ((t = this._dotLottieCommonPlayer.getManifest()) == null ? void 0 : t.animations.length) || 0;
    }
    animations() {
        if (!this._dotLottieCommonPlayer) return [];
        let t = this._dotLottieCommonPlayer.getManifest();
        return (t == null ? void 0 : t.animations.map((e)=>e.id)) || [];
    }
    currentAnimation() {
        return !this._dotLottieCommonPlayer || !this._dotLottieCommonPlayer.currentAnimationId ? "" : this._dotLottieCommonPlayer.currentAnimationId;
    }
    getState() {
        return this._dotLottieCommonPlayer ? this._dotLottieCommonPlayer.getState() : (0, $6hxRz.i);
    }
    getManifest() {
        var t;
        return (t = this._dotLottieCommonPlayer) == null ? void 0 : t.getManifest();
    }
    getLottie() {
        var t;
        return (t = this._dotLottieCommonPlayer) == null ? void 0 : t.getAnimationInstance();
    }
    getVersions() {
        return {
            lottieWebVersion: (0, $6hxRz.j).getLottieWebVersion(),
            dotLottiePlayerVersion: `${$995049a942ccbcb3$var$I.version}`
        };
    }
    previous(t) {
        var e;
        (e = this._dotLottieCommonPlayer) == null || e.previous(t);
    }
    next(t) {
        var e;
        (e = this._dotLottieCommonPlayer) == null || e.next(t);
    }
    reset() {
        var t;
        (t = this._dotLottieCommonPlayer) == null || t.reset();
    }
    play(t, e) {
        this._dotLottieCommonPlayer && this._dotLottieCommonPlayer.play(t, e);
    }
    pause() {
        this._dotLottieCommonPlayer && this._dotLottieCommonPlayer.pause();
    }
    stop() {
        this._dotLottieCommonPlayer && this._dotLottieCommonPlayer.stop();
    }
    playOnShow(t) {
        this._dotLottieCommonPlayer && this._dotLottieCommonPlayer.playOnShow(t);
    }
    stopPlayOnShow() {
        this._dotLottieCommonPlayer && this._dotLottieCommonPlayer.stopPlayOnShow();
    }
    playOnScroll(t) {
        this._dotLottieCommonPlayer && this._dotLottieCommonPlayer.playOnScroll(t);
    }
    stopPlayOnScroll() {
        this._dotLottieCommonPlayer && this._dotLottieCommonPlayer.stopPlayOnScroll();
    }
    seek(t) {
        this._dotLottieCommonPlayer && this._dotLottieCommonPlayer.seek(t);
    }
    snapshot(t = !0) {
        if (!this.shadowRoot) return "";
        let e = this.shadowRoot.querySelector(".animation svg"), i = new XMLSerializer().serializeToString(e);
        if (t) {
            let n = document.createElement("a");
            n.href = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(i)}`, n.download = `download_${this._seeker}.svg`, document.body.appendChild(n), n.click(), document.body.removeChild(n);
        }
        return i;
    }
    setTheme(t) {
        var e;
        (e = this._dotLottieCommonPlayer) == null || e.setDefaultTheme(t);
    }
    themes() {
        var e;
        if (!this._dotLottieCommonPlayer) return [];
        let t = this._dotLottieCommonPlayer.getManifest();
        return ((e = t == null ? void 0 : t.themes) == null ? void 0 : e.map((i)=>i.id)) || [];
    }
    getDefaultTheme() {
        return this._dotLottieCommonPlayer ? this._dotLottieCommonPlayer.defaultTheme : "";
    }
    getActiveStateMachine() {
        return this._dotLottieCommonPlayer ? this._dotLottieCommonPlayer.activeStateId : "";
    }
    _freeze() {
        this._dotLottieCommonPlayer && this._dotLottieCommonPlayer.freeze();
    }
    setSpeed(t = 1) {
        this._dotLottieCommonPlayer && this._dotLottieCommonPlayer.setSpeed(t);
    }
    setDirection(t) {
        this._dotLottieCommonPlayer && this._dotLottieCommonPlayer.setDirection(t);
    }
    setLooping(t) {
        this._dotLottieCommonPlayer && this._dotLottieCommonPlayer.setLoop(t);
    }
    isLooping() {
        return this._dotLottieCommonPlayer ? this._dotLottieCommonPlayer.loop : !1;
    }
    togglePlay() {
        this._dotLottieCommonPlayer && this._dotLottieCommonPlayer.togglePlay();
    }
    toggleLooping() {
        this._dotLottieCommonPlayer && this._dotLottieCommonPlayer.toggleLoop();
    }
    setPlayMode(t) {
        this._dotLottieCommonPlayer && this._dotLottieCommonPlayer.setMode(t);
    }
    enterInteractiveMode(t) {
        this._dotLottieCommonPlayer && this._dotLottieCommonPlayer.enterInteractiveMode(t);
    }
    exitInteractiveMode() {
        this._dotLottieCommonPlayer && this._dotLottieCommonPlayer.exitInteractiveMode();
    }
    revertToManifestValues(t) {
        var e;
        (e = this._dotLottieCommonPlayer) == null || e.revertToManifestValues(t);
    }
    static get styles() {
        return 0, $2883a5bab490bd30$export$db3b6bfb95261072;
    }
    async firstUpdated() {
        var t;
        this.container = (t = this.shadowRoot) == null ? void 0 : t.querySelector("#animation"), "IntersectionObserver" in window && (this._io = new IntersectionObserver((e)=>{
            var i, n;
            e[0] !== void 0 && e[0].isIntersecting ? ((i = this._dotLottieCommonPlayer) == null ? void 0 : i.currentState) === (0, $6hxRz.f).Frozen && this.play() : ((n = this._dotLottieCommonPlayer) == null ? void 0 : n.currentState) === (0, $6hxRz.f).Playing && this._freeze();
        }), this._io.observe(this.container)), this.loop ? this._parseLoop(this.loop) : this.hasAttribute("loop") && this._parseLoop("true"), this.renderer === "svg" ? this._renderer = "svg" : this.renderer === "canvas" ? this._renderer = "canvas" : this.renderer === "html" && (this._renderer = "html"), this.src && await this.load(this.src);
    }
    disconnectedCallback() {
        var t, e;
        this._io && (this._io.disconnect(), this._io = void 0), (t = this._dotLottieCommonPlayer) == null || t.destroy(), (e = this._unsubscribeListeners) == null || e.call(this), window && window.removeEventListener("click", (i)=>this._clickOutListener(i));
    }
    _clickOutListener(t) {
        !t.composedPath().some((i)=>i instanceof HTMLElement ? i.classList.contains("popover") || i.id === "lottie-animation-options" : !1) && this._popoverIsOpen && (this._popoverIsOpen = !1, this.requestUpdate());
    }
    renderControls() {
        var i, n, l, h, b;
        let t = ((i = this._dotLottieCommonPlayer) == null ? void 0 : i.currentState) === (0, $6hxRz.f).Playing, e = ((n = this._dotLottieCommonPlayer) == null ? void 0 : n.currentState) === (0, $6hxRz.f).Paused;
        return (0, $2883a5bab490bd30$export$407448d2b89b1813)`
      <div id="lottie-controls" aria-label="lottie-animation-controls" class="toolbar">
        ${this._hasMultipleAnimations ? (0, $2883a5bab490bd30$export$407448d2b89b1813)`
              <button @click=${()=>this.previous()} aria-label="Previous animation" class="btn-spacing-left">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M1.69214 13.5C1.69214 13.7761 1.916 14 2.19214 14C2.46828 14 2.69214 13.7761 2.69214 13.5L2.69214 2.5C2.69214 2.22386 2.46828 2 2.19214 2C1.916 2 1.69214 2.22386 1.69214 2.5V13.5ZM12.5192 13.7828C13.1859 14.174 14.0254 13.6933 14.0254 12.9204L14.0254 3.0799C14.0254 2.30692 13.1859 1.8262 12.5192 2.21747L4.13612 7.13769C3.47769 7.52414 3.47769 8.4761 4.13612 8.86255L12.5192 13.7828Z"
                    fill="#20272C"
                  />
                </svg>
              </button>
            ` : (0, $2883a5bab490bd30$export$407448d2b89b1813)``}
        <button
          id="lottie-play-button"
          @click=${()=>{
            this.togglePlay();
        }}
          class=${t || e ? `active ${this._hasMultipleAnimations ? "btn-spacing-center" : "btn-spacing-right"}` : `${this._hasMultipleAnimations ? "btn-spacing-center" : "btn-spacing-right"}`}
          aria-label="play / pause animation"
        >
          ${t ? (0, $2883a5bab490bd30$export$407448d2b89b1813)`
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M3.99996 2C3.26358 2 2.66663 2.59695 2.66663 3.33333V12.6667C2.66663 13.403 3.26358 14 3.99996 14H5.33329C6.06967 14 6.66663 13.403 6.66663 12.6667V3.33333C6.66663 2.59695 6.06967 2 5.33329 2H3.99996Z"
                    fill="#20272C"
                  />
                  <path
                    d="M10.6666 2C9.93025 2 9.33329 2.59695 9.33329 3.33333V12.6667C9.33329 13.403 9.93025 14 10.6666 14H12C12.7363 14 13.3333 13.403 13.3333 12.6667V3.33333C13.3333 2.59695 12.7363 2 12 2H10.6666Z"
                    fill="#20272C"
                  />
                </svg>
              ` : (0, $2883a5bab490bd30$export$407448d2b89b1813)`
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M3.33337 3.46787C3.33337 2.52312 4.35948 1.93558 5.17426 2.41379L12.8961 6.94592C13.7009 7.41824 13.7009 8.58176 12.8961 9.05408L5.17426 13.5862C4.35948 14.0644 3.33337 13.4769 3.33337 12.5321V3.46787Z"
                    fill="#20272C"
                  />
                </svg>
              `}
        </button>
        ${this._hasMultipleAnimations ? (0, $2883a5bab490bd30$export$407448d2b89b1813)`
              <button @click=${()=>this.next()} aria-label="Next animation" class="btn-spacing-right">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M14.3336 2.5C14.3336 2.22386 14.1097 2 13.8336 2C13.5574 2 13.3336 2.22386 13.3336 2.5V13.5C13.3336 13.7761 13.5574 14 13.8336 14C14.1097 14 14.3336 13.7761 14.3336 13.5V2.5ZM3.50618 2.21722C2.83954 1.82595 2 2.30667 2 3.07965V12.9201C2 13.6931 2.83954 14.1738 3.50618 13.7825L11.8893 8.86231C12.5477 8.47586 12.5477 7.52389 11.8893 7.13745L3.50618 2.21722Z"
                    fill="#20272C"
                  />
                </svg>
              </button>
            ` : (0, $2883a5bab490bd30$export$407448d2b89b1813)``}
        <input
          id="lottie-seeker-input"
          class="seeker ${((l = this._dotLottieCommonPlayer) == null ? void 0 : l.direction) === -1 ? "to-left" : ""}"
          type="range"
          min="0"
          step="1"
          max="100"
          .value=${this._seeker}
          @input=${(s)=>this._handleSeekChange(s)}
          @mousedown=${()=>{
            this._freeze();
        }}
          @mouseup=${()=>{
            var s;
            (s = this._dotLottieCommonPlayer) == null || s.unfreeze();
        }}
          aria-valuemin="1"
          aria-valuemax="100"
          role="slider"
          aria-valuenow=${this._seeker}
          aria-label="lottie-seek-input"
          style=${`--seeker: ${this._seeker}`}
        />
        <button
          id="lottie-loop-toggle"
          @click=${()=>this.toggleLooping()}
          class=${(h = this._dotLottieCommonPlayer) != null && h.loop ? "active btn-spacing-left" : "btn-spacing-left"}
          aria-label="loop-toggle"
        >
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M10.8654 2.31319C11.0607 2.11793 11.3772 2.11793 11.5725 2.31319L13.4581 4.19881C13.6534 4.39407 13.6534 4.71066 13.4581 4.90592L11.5725 6.79154C11.3772 6.9868 11.0607 6.9868 10.8654 6.79154C10.6701 6.59628 10.6701 6.27969 10.8654 6.08443L11.6162 5.33362H4V6.66695C4 7.03514 3.70152 7.33362 3.33333 7.33362C2.96514 7.33362 2.66666 7.03514 2.66666 6.66695L2.66666 4.66695C2.66666 4.29876 2.96514 4.00028 3.33333 4.00028H11.8454L10.8654 3.0203C10.6701 2.82504 10.6701 2.50846 10.8654 2.31319Z"
              fill="currentColor"
            />
            <path
              d="M12.4375 11.9999C12.8057 11.9999 13.1042 11.7014 13.1042 11.3332V9.33321C13.1042 8.96502 12.8057 8.66655 12.4375 8.66655C12.0693 8.66655 11.7708 8.96502 11.7708 9.33321V10.6665H4.15462L4.90543 9.91573C5.10069 9.72047 5.10069 9.40389 4.90543 9.20862C4.71017 9.01336 4.39359 9.01336 4.19832 9.20862L2.31271 11.0942C2.11744 11.2895 2.11744 11.6061 2.31271 11.8013L4.19832 13.687C4.39359 13.8822 4.71017 13.8822 4.90543 13.687C5.10069 13.4917 5.10069 13.1751 4.90543 12.9799L3.92545 11.9999H12.4375Z"
              fill="currentColor"
            />
          </svg>
        </button>
        ${this._hasMultipleAnimations || this._hasMultipleThemes || this._hasMultipleStates ? (0, $2883a5bab490bd30$export$407448d2b89b1813)`
              <button
                id="lottie-animation-options"
                @click=${()=>{
            this._popoverIsOpen = !this._popoverIsOpen, this.requestUpdate();
        }}
                aria-label="options"
                class="btn-spacing-right"
                style=${`background-color: ${this._popoverIsOpen ? "var(--lottie-player-toolbar-icon-hover-color)" : ""}`}
              >
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M8.33337 11.6666C7.78109 11.6666 7.33337 12.1143 7.33337 12.6666C7.33337 13.2189 7.78109 13.6666 8.33337 13.6666C8.88566 13.6666 9.33337 13.2189 9.33337 12.6666C9.33337 12.1143 8.88566 11.6666 8.33337 11.6666Z"
                    fill="#20272C"
                  />
                  <path
                    d="M7.33337 7.99992C7.33337 7.44763 7.78109 6.99992 8.33337 6.99992C8.88566 6.99992 9.33338 7.44763 9.33338 7.99992C9.33338 8.5522 8.88566 8.99992 8.33337 8.99992C7.78109 8.99992 7.33337 8.5522 7.33337 7.99992Z"
                    fill="#20272C"
                  />
                  <path
                    d="M7.33337 3.33325C7.33337 2.78097 7.78109 2.33325 8.33337 2.33325C8.88566 2.33325 9.33338 2.78097 9.33338 3.33325C9.33338 3.88554 8.88566 4.33325 8.33337 4.33325C7.78109 4.33325 7.33337 3.88554 7.33337 3.33325Z"
                    fill="#20272C"
                  />
                </svg>
              </button>
            ` : (0, $2883a5bab490bd30$export$407448d2b89b1813)``}
      </div>
      ${this._popoverIsOpen ? (0, $2883a5bab490bd30$export$407448d2b89b1813)`
            <div
              id="popover"
              class="popover"
              tabindex="0"
              aria-label="lottie animations themes popover"
              style="min-height: ${this.themes().length > 0 ? "84px" : "auto"}"
            >
              ${!this._animationsTabIsOpen && !this._styleTabIsOpen && !this._statesTabIsOpen ? (0, $2883a5bab490bd30$export$407448d2b89b1813)`
                    <button
                      class="popover-button"
                      tabindex="0"
                      aria-label="animations"
                      @click=${()=>{
            this._animationsTabIsOpen = !this._animationsTabIsOpen, this.requestUpdate();
        }}
                      @keydown=${(s)=>{
            (s.code === "Space" || s.code === "Enter") && (this._animationsTabIsOpen = !this._animationsTabIsOpen, this.requestUpdate());
        }}
                    >
                      <div class="popover-button-text">Animations</div>
                      <div>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M10.4697 17.5303C10.1768 17.2374 10.1768 16.7626 10.4697 16.4697L14.9393 12L10.4697 7.53033C10.1768 7.23744 10.1768 6.76256 10.4697 6.46967C10.7626 6.17678 11.2374 6.17678 11.5303 6.46967L16.5303 11.4697C16.8232 11.7626 16.8232 12.2374 16.5303 12.5303L11.5303 17.5303C11.2374 17.8232 10.7626 17.8232 10.4697 17.5303Z"
                            fill="#4C5863"
                          />
                        </svg>
                      </div>
                    </button>
                  ` : (0, $2883a5bab490bd30$export$407448d2b89b1813)``}
              ${this._hasMultipleThemes && !this._styleTabIsOpen && !this._animationsTabIsOpen && !this._statesTabIsOpen ? (0, $2883a5bab490bd30$export$407448d2b89b1813)` <button
                    class="popover-button"
                    aria-label="Themes"
                    @click=${()=>{
            this._styleTabIsOpen = !this._styleTabIsOpen, this.requestUpdate();
        }}
                    @keydown=${(s)=>{
            (s.code === "Space" || s.code === "Enter") && (this._styleTabIsOpen = !this._styleTabIsOpen, this.requestUpdate());
        }}
                  >
                    <div class="popover-button-text">Themes</div>
                    <div>
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M10.4697 17.5303C10.1768 17.2374 10.1768 16.7626 10.4697 16.4697L14.9393 12L10.4697 7.53033C10.1768 7.23744 10.1768 6.76256 10.4697 6.46967C10.7626 6.17678 11.2374 6.17678 11.5303 6.46967L16.5303 11.4697C16.8232 11.7626 16.8232 12.2374 16.5303 12.5303L11.5303 17.5303C11.2374 17.8232 10.7626 17.8232 10.4697 17.5303Z"
                          fill="#4C5863"
                        />
                      </svg>
                    </div>
                  </button>` : ""}
              ${this._hasMultipleStates && !this._styleTabIsOpen && !this._animationsTabIsOpen && !this._statesTabIsOpen ? (0, $2883a5bab490bd30$export$407448d2b89b1813)` <button
                    class="popover-button"
                    aria-label="States"
                    @click=${()=>{
            this._statesTabIsOpen = !this._statesTabIsOpen, this.requestUpdate();
        }}
                    @keydown=${(s)=>{
            (s.code === "Space" || s.code === "Enter") && (this._statesTabIsOpen = !this._statesTabIsOpen, this.requestUpdate());
        }}
                  >
                    <div class="popover-button-text">States</div>
                    <div>
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M10.4697 17.5303C10.1768 17.2374 10.1768 16.7626 10.4697 16.4697L14.9393 12L10.4697 7.53033C10.1768 7.23744 10.1768 6.76256 10.4697 6.46967C10.7626 6.17678 11.2374 6.17678 11.5303 6.46967L16.5303 11.4697C16.8232 11.7626 16.8232 12.2374 16.5303 12.5303L11.5303 17.5303C11.2374 17.8232 10.7626 17.8232 10.4697 17.5303Z"
                          fill="#4C5863"
                        />
                      </svg>
                    </div>
                  </button>` : ""}
              ${this._animationsTabIsOpen ? (0, $2883a5bab490bd30$export$407448d2b89b1813)`<button
                      class="option-title-button"
                      aria-label="Back to main popover menu"
                      @click=${()=>{
            this._animationsTabIsOpen = !this._animationsTabIsOpen, this.requestUpdate();
        }}
                    >
                      <div class="option-title-chevron">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M13.5303 6.46967C13.8232 6.76256 13.8232 7.23744 13.5303 7.53033L9.06066 12L13.5303 16.4697C13.8232 16.7626 13.8232 17.2374 13.5303 17.5303C13.2374 17.8232 12.7626 17.8232 12.4697 17.5303L7.46967 12.5303C7.17678 12.2374 7.17678 11.7626 7.46967 11.4697L12.4697 6.46967C12.7626 6.17678 13.2374 6.17678 13.5303 6.46967Z"
                            fill="#20272C"
                          />
                        </svg>
                      </div>
                      <div>Animations</div>
                    </button>
                    <div class="option-title-separator"></div>
                    <div class="option-row">
                      <ul>
                        ${this.animations().map((s)=>(0, $2883a5bab490bd30$export$407448d2b89b1813)`
                            <li>
                              <button
                                class="option-button"
                                aria-label=${`${s}`}
                                @click=${()=>{
                this._animationsTabIsOpen = !this._animationsTabIsOpen, this._popoverIsOpen = !this._popoverIsOpen, this.play(s), this.requestUpdate();
            }}
                                @keydown=${(c)=>{
                (c.code === "Space" || c.code === "Enter") && (this._animationsTabIsOpen = !this._animationsTabIsOpen, this._popoverIsOpen = !this._popoverIsOpen, this.play(s), this.requestUpdate());
            }}
                              >
                                <div class="option-tick">
                                  ${this.currentAnimation() === s ? (0, $2883a5bab490bd30$export$407448d2b89b1813)`
                                        <svg
                                          width="24"
                                          height="24"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            fill-rule="evenodd"
                                            clip-rule="evenodd"
                                            d="M20.5281 5.9372C20.821 6.23009 20.821 6.70497 20.5281 6.99786L9.46297 18.063C9.32168 18.2043 9.12985 18.2833 8.93004 18.2826C8.73023 18.2819 8.53895 18.2015 8.39864 18.0593L3.46795 13.0596C3.1771 12.7647 3.1804 12.2898 3.47532 11.999C3.77024 11.7081 4.2451 11.7114 4.53595 12.0063L8.93634 16.4683L19.4675 5.9372C19.7604 5.64431 20.2352 5.64431 20.5281 5.9372Z"
                                            fill="#20272C"
                                          />
                                        </svg>
                                      ` : (0, $2883a5bab490bd30$export$407448d2b89b1813)`<div style="width: 24px; height: 24px"></div>`}
                                </div>
                                <div>${s}</div>
                              </button>
                            </li>
                          `)}
                      </ul>
                    </div> ` : (0, $2883a5bab490bd30$export$407448d2b89b1813)``}
              ${this._styleTabIsOpen ? (0, $2883a5bab490bd30$export$407448d2b89b1813)`<div class="option-title-themes-row">
                      <button
                        class="option-title-button themes"
                        aria-label="Back to main popover menu"
                        @click=${()=>{
            this._styleTabIsOpen = !this._styleTabIsOpen, this.requestUpdate();
        }}
                      >
                        <div class="option-title-chevron">
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M13.5303 6.46967C13.8232 6.76256 13.8232 7.23744 13.5303 7.53033L9.06066 12L13.5303 16.4697C13.8232 16.7626 13.8232 17.2374 13.5303 17.5303C13.2374 17.8232 12.7626 17.8232 12.4697 17.5303L7.46967 12.5303C7.17678 12.2374 7.17678 11.7626 7.46967 11.4697L12.4697 6.46967C12.7626 6.17678 13.2374 6.17678 13.5303 6.46967Z"
                              fill="#20272C"
                            />
                          </svg>
                        </div>
                        <div class="option-title-text">Themes</div>
                        ${((b = this._dotLottieCommonPlayer) == null ? void 0 : b.defaultTheme) === "" ? (0, $2883a5bab490bd30$export$407448d2b89b1813)`` : (0, $2883a5bab490bd30$export$407448d2b89b1813)`
                              <button
                                class="reset-btn"
                                @click=${()=>{
            this.setTheme(""), this.requestUpdate();
        }}
                              >
                                Reset
                              </button>
                            `}
                      </button>
                    </div>
                    <div class="option-title-separator"></div>
                    <div class="option-row">
                      <ul>
                        ${this._themesForCurrentAnimation.map((s)=>(0, $2883a5bab490bd30$export$407448d2b89b1813)`
                            <li>
                              <button
                                class="option-button"
                                aria-label="${s.id}"
                                @click=${()=>{
                this.setTheme(s.id);
            }}
                                @keydown=${(c)=>{
                (c.code === "Space" || c.code === "Enter") && this.setTheme(s.id);
            }}
                              >
                                <div class="option-tick">
                                  ${this.getDefaultTheme() === s.id ? (0, $2883a5bab490bd30$export$407448d2b89b1813)`
                                        <svg
                                          width="24"
                                          height="24"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            fill-rule="evenodd"
                                            clip-rule="evenodd"
                                            d="M20.5281 5.9372C20.821 6.23009 20.821 6.70497 20.5281 6.99786L9.46297 18.063C9.32168 18.2043 9.12985 18.2833 8.93004 18.2826C8.73023 18.2819 8.53895 18.2015 8.39864 18.0593L3.46795 13.0596C3.1771 12.7647 3.1804 12.2898 3.47532 11.999C3.77024 11.7081 4.2451 11.7114 4.53595 12.0063L8.93634 16.4683L19.4675 5.9372C19.7604 5.64431 20.2352 5.64431 20.5281 5.9372Z"
                                            fill="#20272C"
                                          />
                                        </svg>
                                      ` : (0, $2883a5bab490bd30$export$407448d2b89b1813)`<div style="width: 24px; height: 24px"></div>`}
                                </div>
                                <div>${s.id}</div>
                              </button>
                            </li>
                          `)}
                      </ul>
                    </div>` : (0, $2883a5bab490bd30$export$407448d2b89b1813)``}
              ${this._statesTabIsOpen ? (0, $2883a5bab490bd30$export$407448d2b89b1813)`<div class="option-title-themes-row">
                      <button
                        class="option-title-button themes"
                        aria-label="Back to main popover menu"
                        @click=${()=>{
            this._statesTabIsOpen = !this._statesTabIsOpen, this.requestUpdate();
        }}
                      >
                        <div class="option-title-chevron">
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M13.5303 6.46967C13.8232 6.76256 13.8232 7.23744 13.5303 7.53033L9.06066 12L13.5303 16.4697C13.8232 16.7626 13.8232 17.2374 13.5303 17.5303C13.2374 17.8232 12.7626 17.8232 12.4697 17.5303L7.46967 12.5303C7.17678 12.2374 7.17678 11.7626 7.46967 11.4697L12.4697 6.46967C12.7626 6.17678 13.2374 6.17678 13.5303 6.46967Z"
                              fill="#20272C"
                            />
                          </svg>
                        </div>
                        <div class="option-title-text">States</div>
                        <button
                          class="reset-btn"
                          @click=${()=>{
            this.exitInteractiveMode(), this.requestUpdate();
        }}
                        >
                          Reset
                        </button>
                      </button>
                    </div>
                    <div class="option-title-separator"></div>
                    <div class="option-row">
                      <ul>
                        ${this._statesForCurrentAnimation.map((s)=>(0, $2883a5bab490bd30$export$407448d2b89b1813)`
                            <li>
                              <button
                                class="option-button"
                                aria-label="${s}"
                                @click=${()=>{
                this.enterInteractiveMode(s);
            }}
                                @keydown=${(c)=>{
                (c.code === "Space" || c.code === "Enter") && this.enterInteractiveMode(s);
            }}
                              >
                                <div class="option-tick">
                                  ${this.getActiveStateMachine() === s ? (0, $2883a5bab490bd30$export$407448d2b89b1813)`
                                        <svg
                                          width="24"
                                          height="24"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            fill-rule="evenodd"
                                            clip-rule="evenodd"
                                            d="M20.5281 5.9372C20.821 6.23009 20.821 6.70497 20.5281 6.99786L9.46297 18.063C9.32168 18.2043 9.12985 18.2833 8.93004 18.2826C8.73023 18.2819 8.53895 18.2015 8.39864 18.0593L3.46795 13.0596C3.1771 12.7647 3.1804 12.2898 3.47532 11.999C3.77024 11.7081 4.2451 11.7114 4.53595 12.0063L8.93634 16.4683L19.4675 5.9372C19.7604 5.64431 20.2352 5.64431 20.5281 5.9372Z"
                                            fill="#20272C"
                                          />
                                        </svg>
                                      ` : (0, $2883a5bab490bd30$export$407448d2b89b1813)`<div style="width: 24px; height: 24px"></div>`}
                                </div>
                                <div>${s}</div>
                              </button>
                            </li>
                          `)}
                      </ul>
                    </div>` : (0, $2883a5bab490bd30$export$407448d2b89b1813)``}
            </div>
          ` : (0, $2883a5bab490bd30$export$407448d2b89b1813)``}
    `;
    }
    render() {
        var i;
        let t = this.controls ? "main controls" : "main", e = this.controls ? "animation controls" : "animation";
        return (0, $2883a5bab490bd30$export$407448d2b89b1813)`
      <div id="animation-container" class=${t} lang="en" role="img" aria-label="lottie-animation-container">
        <div id="animation" class=${e} style="background:${this.background};">
          ${((i = this._dotLottieCommonPlayer) == null ? void 0 : i.currentState) === (0, $6hxRz.f).Error ? (0, $2883a5bab490bd30$export$407448d2b89b1813)` <div class="error">⚠️</div> ` : void 0}
        </div>
        ${this.controls ? this.renderControls() : void 0}
      </div>
    `;
    }
};
(0, $bL0Ij.a)([
    $995049a942ccbcb3$var$p({
        type: String
    })
], $995049a942ccbcb3$export$a44c8d2ddace26de.prototype, "defaultTheme", 2), (0, $bL0Ij.a)([
    $995049a942ccbcb3$var$O("#animation")
], $995049a942ccbcb3$export$a44c8d2ddace26de.prototype, "container", 2), (0, $bL0Ij.a)([
    $995049a942ccbcb3$var$p()
], $995049a942ccbcb3$export$a44c8d2ddace26de.prototype, "playMode", 2), (0, $bL0Ij.a)([
    $995049a942ccbcb3$var$p({
        type: Boolean
    })
], $995049a942ccbcb3$export$a44c8d2ddace26de.prototype, "autoplay", 2), (0, $bL0Ij.a)([
    $995049a942ccbcb3$var$p({
        type: String
    })
], $995049a942ccbcb3$export$a44c8d2ddace26de.prototype, "background", 2), (0, $bL0Ij.a)([
    $995049a942ccbcb3$var$p({
        type: Boolean
    })
], $995049a942ccbcb3$export$a44c8d2ddace26de.prototype, "controls", 2), (0, $bL0Ij.a)([
    $995049a942ccbcb3$var$p({
        type: Number
    })
], $995049a942ccbcb3$export$a44c8d2ddace26de.prototype, "direction", 2), (0, $bL0Ij.a)([
    $995049a942ccbcb3$var$p({
        type: Boolean
    })
], $995049a942ccbcb3$export$a44c8d2ddace26de.prototype, "hover", 2), (0, $bL0Ij.a)([
    $995049a942ccbcb3$var$p({
        type: String
    })
], $995049a942ccbcb3$export$a44c8d2ddace26de.prototype, "loop", 2), (0, $bL0Ij.a)([
    $995049a942ccbcb3$var$p({
        type: String
    })
], $995049a942ccbcb3$export$a44c8d2ddace26de.prototype, "renderer", 2), (0, $bL0Ij.a)([
    $995049a942ccbcb3$var$p({
        type: Number
    })
], $995049a942ccbcb3$export$a44c8d2ddace26de.prototype, "speed", 2), (0, $bL0Ij.a)([
    $995049a942ccbcb3$var$p({
        type: String
    })
], $995049a942ccbcb3$export$a44c8d2ddace26de.prototype, "src", 2), (0, $bL0Ij.a)([
    $995049a942ccbcb3$var$p()
], $995049a942ccbcb3$export$a44c8d2ddace26de.prototype, "intermission", 2), (0, $bL0Ij.a)([
    $995049a942ccbcb3$var$p({
        type: String
    })
], $995049a942ccbcb3$export$a44c8d2ddace26de.prototype, "activeAnimationId", 2), (0, $bL0Ij.a)([
    $995049a942ccbcb3$var$p({
        type: Boolean
    })
], $995049a942ccbcb3$export$a44c8d2ddace26de.prototype, "light", 2), (0, $bL0Ij.a)([
    $995049a942ccbcb3$var$p({
        type: Boolean
    })
], $995049a942ccbcb3$export$a44c8d2ddace26de.prototype, "worker", 2), (0, $bL0Ij.a)([
    $995049a942ccbcb3$var$p({
        type: String
    })
], $995049a942ccbcb3$export$a44c8d2ddace26de.prototype, "activeStateId", 2), (0, $bL0Ij.a)([
    $995049a942ccbcb3$var$k()
], $995049a942ccbcb3$export$a44c8d2ddace26de.prototype, "_seeker", 2);
customElements.get($995049a942ccbcb3$var$T) || customElements.define($995049a942ccbcb3$var$T, $995049a942ccbcb3$export$a44c8d2ddace26de); /*! Bundled license information:

@lit/reactive-element/decorators/custom-element.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

@lit/reactive-element/decorators/property.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

@lit/reactive-element/decorators/state.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

@lit/reactive-element/decorators/base.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

@lit/reactive-element/decorators/event-options.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

@lit/reactive-element/decorators/query.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

@lit/reactive-element/decorators/query-all.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

@lit/reactive-element/decorators/query-async.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

@lit/reactive-element/decorators/query-assigned-elements.js:
  (**
   * @license
   * Copyright 2021 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

@lit/reactive-element/decorators/query-assigned-nodes.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)
*/ 
 //# sourceMappingURL=out.js.map


//# sourceMappingURL=index.c9ffc2a1.js.map
